export default {
  id: 'mentalHealth',
  version: '16',
  type: 'formulary',
  children: [
    {
      type: 'section',
      children: [
        {
          id: 'mentalHealth.screen',
          type: 'choice',
          version: '4',
          options: [
            {
              value: 'no',
              label:
                'Nej, jag har inte tankar på att ta mitt liv eller på att skada mig själv eller någon annan.',
            },
            {
              value: 'yes',
              label:
                'Ja, jag har tankar på att ta mitt liv eller på att skada mig själv eller någon annan.',
            },
          ],
          validations: {
            required: true,
          },
          description:
            '  <p>\n    De allra flesta symptom på psykisk obalans kan Min Doktor hjälpa dig med. Vissa tillstånd lämpar sig dock inte för digital vård, utan kräver ett mer akut omhändertagande.\n  </p>\n\n  <p>\n    Du behöver ta ställning till om du har tankar på att ta ditt liv eller på att skada dig själv eller någon annan. Har du sådana tankar ska du söka dig direkt till närmaste psykiatriska akutmottagning för att få rätt hjälp. Ring 1177 om du är osäker på var denna mottagning finns.\n  </p>\n\n  <p>\n    Har du tankar på att ta ditt liv eller på att skada dig själv eller någon annan?\n  </p>',
          index: '0.0.0',
        },
      ],
      index: '0.0',
    },
    {
      type: 'section',
      children: [
        {
          id: 'mentalHealth.currentContact',
          type: 'binary',
          version: '1',
          validations: {
            required: true,
          },
          label:
            'Har du kontakt med psykiatrivården eller kontinuerlig kontakt med husläkare/vårdcentral för de besvär du söker hjälp för?',
          index: '0.1.0',
        },
        {
          id: 'mentalHealth.consent',
          type: 'confirm',
          version: '1',
          validations: {
            required: true,
          },
          label: 'Jag förstår',
          description:
            '  Min Doktor riktar sig i första hand till dig som har tillfälliga eller lättare psykiska besvär. Vi tror och hoppas att vi ska kunna hjälpa dig på allra bästa sätt.',
          index: '0.1.1',
        },
      ],
      version: '1',
      index: '0.1',
    },
    {
      type: 'section',
      children: [
        {
          id: 'problem.duration',
          type: 'choice',
          version: '1',
          numeric: true,
          options: [
            {
              value: 2,
              label: 'Några dagar',
            },
            {
              value: 7,
              label: 'En vecka',
            },
            {
              value: 14,
              label: '2-3 veckor',
            },
            {
              value: 31,
              label: 'En månad',
            },
            {
              value: 90,
              label: 'Flera månader',
            },
            {
              value: 365,
              label: 'Ett år',
            },
            {
              value: 730,
              label: 'Flera år',
            },
          ],
          validations: {
            required: true,
          },
          label: 'Hur länge har du haft besvären?',
          index: '0.2.0',
        },
        {
          id: 'problem.frequency',
          type: 'choice',
          options: [
            {
              value: 'daily',
              label: 'Dagligen',
            },
            {
              value: 'multipleTimesAWeek',
              label: 'Flera gånger i veckan',
            },
            {
              value: 'weekly',
              label: 'Någon gång i veckan',
            },
          ],
          version: '1',
          validations: {
            required: true,
          },
          label: 'Hur ofta uppträder besvären?',
          index: '0.2.1',
        },
      ],
      version: '1',
      index: '0.2',
    },
    {
      type: 'section',
      children: [
        {
          id: 'problem.similar',
          type: 'binary',
          version: '1',
          validations: {
            required: true,
          },
          label: 'Har du haft liknande besvär tidigare?',
          index: '0.3.0',
        },
        {
          id: 'problem.similarWhen',
          type: 'choice',
          options: [
            {
              value: 'month',
              label: 'För ca en månad sedan',
            },
            {
              value: '6months',
              label: 'För ca ett halvår sedan',
            },
            {
              value: 'year',
              label: 'För ca ett år sedan',
            },
            {
              value: 'severalYears',
              label: 'För flera år sedan',
            },
          ],
          version: '1',
          condition: "get('answers.problem.similar') === 'yes'",
          validations: {
            required: true,
          },
          label: 'När hade du liknande besvär?',
          index: '0.3.1',
        },
        {
          id: 'problem.similarTreatment',
          type: 'composite',
          version: '1',
          children: [
            {
              id: 'problem.similarTreatment.what',
              type: 'multipleChoice',
              options: [
                {
                  value: 'antidepressive',
                  label: 'Antidepressiv',
                },
                {
                  value: 'calming',
                  label: 'Lugnande',
                },
                {
                  value: 'sleeping',
                  label: 'Sömnmedel',
                },
                {
                  value: 'moodStabilizing',
                  label: 'Stämningsstabiliserande',
                },
                {
                  value: 'antipsychotic',
                  label: 'Antipsykotisk',
                },
                {
                  value: 'thyroidGlandHormone',
                  label: 'Sköldkörtelhormon',
                },
                {
                  value: 'psychoTherapy',
                  label: 'Psykoterapi',
                },
                {
                  value: 'unknown',
                  label: 'Ingen/Vet ej',
                },
              ],
              relativeId: 'what',
              version: '1',
              validations: {
                required: false,
              },
              label: 'Vilken behandling fick du?',
              index: '0.3.2.0',
            },
          ],
          condition: "get('answers.problem.similar') === 'yes'",
          extras: {},
          index: '0.3.2',
        },
      ],
      version: '1',
      index: '0.3',
    },
    {
      type: 'section',
      children: [
        {
          id: 'mentalHealth.relatives',
          type: 'composite',
          version: '1',
          children: [
            {
              id: 'mentalHealth.relatives.match',
              type: 'tertiary',
              relativeId: 'match',
              version: '1',
              validations: {
                required: true,
              },
              label:
                'Finns det någon i din släkt som har eller har haft liknande besvär eller annan psykisk ohälsa?',
              index: '0.4.0.0',
            },
          ],
          extras: {},
          index: '0.4.0',
        },
        {
          id: 'mentalHealth.recentHardships',
          type: 'composite',
          version: '1',
          children: [
            {
              id: 'mentalHealth.recentHardships.match',
              type: 'multipleChoice',
              options: [
                {
                  value: 'family',
                  label: 'Familj',
                },
                {
                  value: 'work',
                  label: 'Arbete',
                },
                {
                  value: 'economy',
                  label: 'Ekonomi',
                },
                {
                  value: 'social',
                  label: 'Socialt',
                },
                {
                  value: 'accident',
                  label: 'Varit med om en olycka',
                },
                {
                  value: 'crime',
                  label: 'Utsatt för brott',
                },
                {
                  value: 'divorce',
                  label: 'Skilsmässa',
                },
                {
                  value: 'seriousIllness',
                  label: 'Allvarlig sjukdom',
                },
                {
                  value: 'death',
                  label: 'Närståendes död',
                },
              ],
              validations: {
                required: false,
              },
              relativeId: 'match',
              version: '1',
              label:
                'Har du under det senaste året varit med om svårigheter eller påfrestningar inom något eller några av följande områden? Om inte, hoppa över denna fråga.',
              index: '0.4.1.0',
            },
            {
              id: 'mentalHealth.recentHardships.followup',
              type: 'text',
              condition:
                "length(get('answers.mentalHealth.recentHardships.match')) > 0",
              relativeId: 'followup',
              version: '1',
              validations: {
                required: true,
              },
              label: 'Beskriv kort svårigheterna',
              index: '0.4.1.1',
            },
          ],
          extras: {},
          index: '0.4.1',
        },
      ],
      version: '1',
      index: '0.4',
    },
    {
      type: 'section',
      children: [
        {
          id: 'social.livingArrangement',
          type: 'choice',
          options: [
            {
              value: 'alone',
              label: 'Ensam',
            },
            {
              value: 'partnerAndOrChildren',
              label: 'Med partner och/eller barn',
            },
            {
              value: 'parents',
              label: 'Med föräldrar',
            },
            {
              value: 'other',
              label: 'Annat',
            },
          ],
          version: '1',
          validations: {
            required: true,
          },
          label: 'Hur bor du?',
          index: '0.5.0',
        },
        {
          id: 'social.familyRelations',
          type: 'choice',
          options: [
            {
              value: 'good',
              label: 'Goda',
            },
            {
              value: 'mostlyGood',
              label: 'I huvudsak goda',
            },
            {
              value: 'complicated',
              label: 'Komplicerade',
            },
            {
              value: 'poor',
              label: 'Dåliga',
            },
          ],
          version: '1',
          validations: {
            required: true,
          },
          label: 'Hur är dina familjerelationer?',
          index: '0.5.1',
        },
        {
          id: 'social.haveFriends',
          type: 'binary',
          version: '1',
          validations: {
            required: true,
          },
          label: 'Har du någon eller några goda vänner?',
          index: '0.5.2',
        },
        {
          id: 'education.level',
          type: 'choice',
          options: [
            {
              value: 'basic',
              label: 'Grundskola',
            },
            {
              value: 'highSchool',
              label: 'Gymnasieskola',
            },
            {
              value: 'collegeUniversity',
              label: 'Högskola/Universitet',
            },
          ],
          version: '1',
          validations: {
            required: true,
          },
          label: 'Vilken är din högsta avslutade utbildning?',
          index: '0.5.3',
        },
        {
          id: 'work.what',
          type: 'choice',
          options: [
            {
              value: 'office',
              label: 'Kontorsarbete',
            },
            {
              value: 'sales',
              label: 'Försäljning',
            },
            {
              value: 'industry',
              label: 'Industri/verkstad',
            },
            {
              value: 'construction',
              label: 'Bygg/anläggning',
            },
            {
              value: 'transport',
              label: 'Transport',
            },
            {
              value: 'healthcare',
              label: 'Hälso och sjukvård',
            },
            {
              value: 'unemployed',
              label: 'Arbetslös',
            },
            {
              value: 'other',
              label: 'Annat',
            },
          ],
          version: '1',
          validations: {
            required: true,
          },
          label: 'Vad arbetar du med?',
          index: '0.5.4',
        },
        {
          id: 'work.selfEmployed',
          type: 'binary',
          version: '1',
          condition:
            "get('answers.work.what') && get('answers.work.what') !== 'unemployed'",
          validations: {
            required: true,
          },
          label: 'Är du egen företagare?',
          index: '0.5.5',
        },
        {
          id: 'work.happy',
          type: 'range',
          version: '1',
          min: {
            value: 0,
            label: 'Mycket missnöjd',
          },
          max: {
            value: 10,
            label: 'Mycket nöjd',
          },
          extras: {
            vas: false,
            invert: false,
          },
          condition:
            "get('answers.work.what') && get('answers.work.what') !== 'unemployed'",
          validations: {
            required: true,
          },
          label: 'Hur nöjd är du med din nuvarande arbetssituation?',
          index: '0.5.6',
        },
        {
          id: 'work.shift',
          type: 'binary',
          version: '1',
          condition:
            "get('answers.work.what') && get('answers.work.what') !== 'unemployed'",
          validations: {
            required: true,
          },
          label: 'Har du ett skiftarbete?',
          index: '0.5.7',
        },
        {
          id: 'work.amount',
          type: 'composite',
          version: '1',
          children: [
            {
              id: 'work.amount.type',
              type: 'choice',
              options: [
                {
                  value: 'fullTime',
                  label: 'Heltid',
                },
                {
                  value: 'partTime',
                  label: 'Deltid',
                },
                {
                  value: 'leaveOfAbsence',
                  label: 'Tjänstledig',
                },
                {
                  value: 'sickLeave',
                  label: 'Sjukskriven',
                },
                {
                  value: 'other',
                  label: 'Annat',
                },
              ],
              relativeId: 'type',
              version: '1',
              validations: {
                required: true,
              },
              label: 'Hur mycket arbetar du?',
              index: '0.5.8.0',
            },
            {
              id: 'work.amount.sickLeaveWhen',
              type: 'choice',
              options: [
                {
                  value: 'lessThanMonth',
                  label: 'Mindre än en månad',
                },
                {
                  value: 'moreThanMonth',
                  label: 'Mer än en månad',
                },
                {
                  value: 'moreThan6Months',
                  label: 'Mer än 6 månader',
                },
              ],
              condition: "get('answers.work.amount.type') === 'sickLeave'",
              relativeId: 'sickLeaveWhen',
              version: '1',
              validations: {
                required: true,
              },
              label: 'Hur länge har du varit sjukskriven?',
              index: '0.5.8.1',
            },
            {
              id: 'work.amount.sickLeaveWhy',
              type: 'choice',
              options: [
                {
                  value: 'chronic',
                  label: 'Kronisk sjukdom',
                },
                {
                  value: 'tear',
                  label: 'Förslitningsskada',
                },
                {
                  value: 'mental',
                  label: 'Psykiska besvär',
                },
                {
                  value: 'accident',
                  label: 'Olycksfall',
                },
                {
                  value: 'other',
                  label: 'Annat',
                },
              ],
              condition: "get('answers.work.amount.type') === 'sickLeave'",
              relativeId: 'sickLeaveWhy',
              version: '1',
              validations: {
                required: true,
              },
              label: 'Varför är du sjukskriven?',
              index: '0.5.8.2',
            },
          ],
          condition:
            "get('answers.work.what') && get('answers.work.what') !== 'unemployed'",
          extras: {},
          index: '0.5.8',
        },
        {
          id: 'exercise.regularly',
          type: 'binary',
          version: '1',
          validations: {
            required: true,
          },
          label: 'Motionerar du regelbundet?',
          index: '0.5.9',
        },
        {
          id: 'sleep.well',
          type: 'binary',
          version: '1',
          validations: {
            required: true,
          },
          label: 'Är din sömn god?',
          index: '0.5.10',
        },
        {
          id: 'sleep.recentIssues',
          type: 'binary',
          version: '1',
          condition: "get('answers.sleep.well') === 'no'",
          validations: {
            required: true,
          },
          label: 'Är dina sömnproblem nytillkomna?',
          index: '0.5.11',
        },
      ],
      version: '1',
      index: '0.5',
    },
    {
      type: 'section',
      children: [
        {
          id: 'reproduction.pms',
          type: 'tertiary',
          version: '1',
          condition:
            "get('answers.predefined.gender') === 'female' && get('answers.predefined.age') >= 18 && get('answers.predefined.age') <= 60",
          validations: {
            required: true,
          },
          label: 'Har du PMS?',
          index: '0.6.0',
        },
        {
          id: 'health.hormones',
          type: 'tertiary',
          version: '1',
          validations: {
            required: true,
          },
          label: 'Har du någon sköldkörtelrubbning eller annan hormonrubbning?',
          index: '0.6.1',
        },
        {
          id: 'reproduction.recentlyInLabor',
          type: 'binary',
          version: '1',
          condition:
            "get('answers.predefined.gender') === 'female' && get('answers.predefined.age') >= 18 && get('answers.predefined.age') <= 50",
          validations: {
            required: true,
          },
          label: 'Har du fött barn under det senaste året?',
          index: '0.6.2',
        },
        {
          id: 'reproduction.menopause',
          type: 'tertiary',
          version: '1',
          condition:
            "get('answers.predefined.gender') === 'female' && get('answers.predefined.age') >= 40 && get('answers.predefined.age') <= 60",
          validations: {
            required: true,
          },
          label: 'Är du i menopaus (klimakteriet)?',
          index: '0.6.3',
        },
        {
          id: 'health.chronicPain',
          type: 'binary',
          version: '1',
          validations: {
            required: true,
          },
          label:
            'Besväras du av kronisk eller långvarig smärta pga sjukdom eller olycka?',
          index: '0.6.4',
        },
      ],
      version: '1',
      index: '0.6',
    },
    {
      type: 'section',
      children: [
        {
          id: 'alcohol.related',
          type: 'binary',
          version: '1',
          validations: {
            required: true,
          },
          label: 'Är du orolig för att du konsumerar för mycket alkohol?',
          index: '0.7.0',
        },
      ],
      index: '0.7',
    },
    {
      type: 'section',
      condition: "get('variables.mentalHealth.problem.longDuration') === 'no'",
      children: [
        {
          id: 'had.status',
          type: 'composite',
          version: '2',
          children: [
            {
              id: 'had.status.tense',
              type: 'choice',
              options: [
                {
                  value: 3,
                  label: 'Ofta',
                },
                {
                  value: 2,
                  label: 'Av och till',
                },
                {
                  value: 1,
                  label: 'Ibland',
                },
                {
                  value: 0,
                  label: 'Inte alls',
                },
              ],
              relativeId: 'tense',
              version: '2',
              validations: {
                required: true,
              },
              label: 'Jag känner mig spänd eller nervös.',
              description:
                'Läs igenom varje påstående och sätt ett kryss i den ruta som bäst beskriver hur du har känt dig den senaste veckan. Fundera inte för länge över dina svar; din spontana reaktion inför varje påstående är förmodligen mer korrekt än ett svar som du tänkt på länge.',
              index: '0.8.0.0',
            },
            {
              id: 'had.status.appreciative',
              type: 'choice',
              options: [
                {
                  value: 0,
                  label: 'Definitivt lika mycket',
                },
                {
                  value: 1,
                  label: 'Inte lika mycket',
                },
                {
                  value: 2,
                  label: 'Endast delvis',
                },
                {
                  value: 3,
                  label: 'Nästan inte alls',
                },
              ],
              relativeId: 'appreciative',
              version: '2',
              validations: {
                required: true,
              },
              label:
                'Jag uppskattar fortfarande saker jag tidigare uppskattat.',
              description:
                'Sätt ett kryss i den ruta som bäst beskriver hur du har känt dig den senaste veckan.',
              index: '0.8.0.1',
            },
            {
              id: 'had.status.horrible',
              type: 'choice',
              options: [
                {
                  value: 3,
                  label: 'Mycket klart och obehagligt',
                },
                {
                  value: 2,
                  label: 'Inte så starkt nu',
                },
                {
                  value: 1,
                  label: 'Betydligt svagare nu',
                },
                {
                  value: 0,
                  label: 'Inte alls',
                },
              ],
              relativeId: 'horrible',
              version: '2',
              validations: {
                required: true,
              },
              label: 'Jag har en känsla av att något hemskt kommer att hända.',
              description:
                'Sätt ett kryss i den ruta som bäst beskriver hur du har känt dig den senaste veckan.',
              index: '0.8.0.2',
            },
            {
              id: 'had.status.laugh',
              type: 'choice',
              options: [
                {
                  value: 0,
                  label: 'Lika ofta som tidigare',
                },
                {
                  value: 1,
                  label: 'Inte lika ofta nu',
                },
                {
                  value: 2,
                  label: 'Betydligt mer sällan nu',
                },
                {
                  value: 3,
                  label: 'Aldrig',
                },
              ],
              relativeId: 'laugh',
              version: '2',
              validations: {
                required: true,
              },
              label: 'Jag kan skratta och se det roliga i saker och ting.',
              description:
                'Sätt ett kryss i den ruta som bäst beskriver hur du har känt dig den senaste veckan.',
              index: '0.8.0.3',
            },
            {
              id: 'had.status.worry',
              type: 'choice',
              options: [
                {
                  value: 3,
                  label: 'Mestadels',
                },
                {
                  value: 2,
                  label: 'Ganska ofta',
                },
                {
                  value: 1,
                  label: 'Av och till',
                },
                {
                  value: 0,
                  label: 'Någon enstaka gång',
                },
              ],
              relativeId: 'worry',
              version: '2',
              validations: {
                required: true,
              },
              label: 'Jag bekymrar mig över saker.',
              description:
                'Sätt ett kryss i den ruta som bäst beskriver hur du har känt dig den senaste veckan.',
              index: '0.8.0.4',
            },
            {
              id: 'had.status.goodMood',
              type: 'choice',
              options: [
                {
                  value: 3,
                  label: 'Aldrig',
                },
                {
                  value: 2,
                  label: 'Sällan',
                },
                {
                  value: 1,
                  label: 'Ibland',
                },
                {
                  value: 0,
                  label: 'Mestadels',
                },
              ],
              relativeId: 'goodMood',
              version: '2',
              validations: {
                required: true,
              },
              label: 'Jag känner mig på gott humör.',
              description:
                'Sätt ett kryss i den ruta som bäst beskriver hur du har känt dig den senaste veckan.',
              index: '0.8.0.5',
            },
            {
              id: 'had.status.relaxed',
              type: 'choice',
              options: [
                {
                  value: 0,
                  label: 'Definitivt',
                },
                {
                  value: 1,
                  label: 'Vanligtvis',
                },
                {
                  value: 2,
                  label: 'Sällan',
                },
                {
                  value: 3,
                  label: 'Aldrig',
                },
              ],
              relativeId: 'relaxed',
              version: '2',
              validations: {
                required: true,
              },
              label: 'Jag kan sitta stilla och känna mig avslappnad.',
              description:
                'Sätt ett kryss i den ruta som bäst beskriver hur du har känt dig den senaste veckan.',
              index: '0.8.0.6',
            },
            {
              id: 'had.status.slow',
              type: 'choice',
              options: [
                {
                  value: 3,
                  label: 'Mestadels',
                },
                {
                  value: 2,
                  label: 'Nästan alltid',
                },
                {
                  value: 1,
                  label: 'Ofta',
                },
                {
                  value: 0,
                  label: 'Aldrig',
                },
              ],
              relativeId: 'slow',
              version: '2',
              validations: {
                required: true,
              },
              label: 'Allting känns trögt.',
              description:
                'Sätt ett kryss i den ruta som bäst beskriver hur du har känt dig den senaste veckan.',
              index: '0.8.0.7',
            },
            {
              id: 'had.status.butterflies',
              type: 'choice',
              options: [
                {
                  value: 0,
                  label: 'Aldrig',
                },
                {
                  value: 1,
                  label: 'Ibland',
                },
                {
                  value: 2,
                  label: 'Ganska ofta',
                },
                {
                  value: 3,
                  label: 'Väldigt ofta',
                },
              ],
              relativeId: 'butterflies',
              version: '2',
              validations: {
                required: true,
              },
              label:
                'Jag känner mig orolig, som om jag hade ”fjärilar” i magen.',
              description:
                'Sätt ett kryss i den ruta som bäst beskriver hur du har känt dig den senaste veckan.',
              index: '0.8.0.8',
            },
            {
              id: 'had.status.appearance',
              type: 'choice',
              options: [
                {
                  value: 3,
                  label: 'Fullständigt',
                },
                {
                  value: 2,
                  label: 'Till stor del',
                },
                {
                  value: 1,
                  label: 'Delvis',
                },
                {
                  value: 0,
                  label: 'Inte alls',
                },
              ],
              relativeId: 'appearance',
              version: '2',
              validations: {
                required: true,
              },
              label: 'Jag har tappat intresset för hur jag ser ut.',
              description:
                'Sätt ett kryss i den ruta som bäst beskriver hur du har känt dig den senaste veckan.',
              index: '0.8.0.9',
            },
            {
              id: 'had.status.restless',
              type: 'choice',
              options: [
                {
                  value: 3,
                  label: 'Väldigt ofta',
                },
                {
                  value: 2,
                  label: 'Ganska ofta',
                },
                {
                  value: 1,
                  label: 'Sällan',
                },
                {
                  value: 0,
                  label: 'Inte alls',
                },
              ],
              relativeId: 'restless',
              version: '2',
              validations: {
                required: true,
              },
              label: 'Jag känner mig rastlös.',
              description:
                'Sätt ett kryss i den ruta som bäst beskriver hur du har känt dig den senaste veckan.',
              index: '0.8.0.10',
            },
            {
              id: 'had.status.lookForwardTo',
              type: 'choice',
              options: [
                {
                  value: 0,
                  label: 'Lika mycket som tidigare',
                },
                {
                  value: 1,
                  label: 'Mindre än tidigare',
                },
                {
                  value: 2,
                  label: 'Mycket mindre än tidigare',
                },
                {
                  value: 3,
                  label: 'Knappast alls',
                },
              ],
              relativeId: 'lookForwardTo',
              version: '2',
              validations: {
                required: true,
              },
              label: 'Jag ser med glädje fram emot saker och ting.',
              description:
                'Sätt ett kryss i den ruta som bäst beskriver hur du har känt dig den senaste veckan.',
              index: '0.8.0.11',
            },
            {
              id: 'had.status.panic',
              type: 'choice',
              options: [
                {
                  value: 3,
                  label: 'Väldigt ofta',
                },
                {
                  value: 2,
                  label: 'Ganska ofta',
                },
                {
                  value: 1,
                  label: 'Sällan',
                },
                {
                  value: 0,
                  label: 'Aldrig',
                },
              ],
              relativeId: 'panic',
              version: '2',
              validations: {
                required: true,
              },
              label: 'Jag får plötsliga panikkänslor.',
              description:
                'Sätt ett kryss i den ruta som bäst beskriver hur du har känt dig den senaste veckan.',
              index: '0.8.0.12',
            },
            {
              id: 'had.status.bookTvRadio',
              type: 'choice',
              options: [
                {
                  value: 0,
                  label: 'Ofta',
                },
                {
                  value: 1,
                  label: 'Ibland',
                },
                {
                  value: 2,
                  label: 'Sällan',
                },
                {
                  value: 3,
                  label: 'Mycket sällan',
                },
              ],
              relativeId: 'bookTvRadio',
              version: '2',
              validations: {
                required: true,
              },
              label:
                'Jag kan uppskatta en god bok, ett TV- eller radioprogram.',
              description:
                'Sätt ett kryss i den ruta som bäst beskriver hur du har känt dig den senaste veckan.',
              index: '0.8.0.13',
            },
          ],
          extras: {},
          index: '0.8.0',
        },
      ],
      version: '1',
      index: '0.8',
    },
    {
      type: 'section',
      condition: "get('variables.mentalHealth.problem.longDuration') === 'yes'",
      children: [
        {
          type: 'section',
          children: [
            {
              type: 'section',
              children: [
                {
                  id: 'adjustment.match',
                  type: 'choice',
                  version: '1',
                  options: [
                    {
                      value: 'yes',
                      label:
                        'Jag har varit utsatt för en starkt negativ livshändelse och/eller har levt med en förhöjd stressnivå under den senaste tremånadersperioden. Detta ger mig så mycket ångest eller gör mig så nedstämd att det påverkar min livskvalitet.',
                    },
                    {
                      value: 'no',
                      label: 'Jag har inte sådana problem nu.',
                    },
                  ],
                  validations: {
                    required: true,
                  },
                  description:
                    '  Det är normalt att känna sig nedstämd och/eller ångestfylld när man har utsatts för en starkt negativ livshändelse eller lever under stress, t.ex. i arbete/studier eller pga familjeproblem. Vad av följande stämmer bäst in på dig?',
                  index: '0.9.0.0.0',
                },
              ],
              index: '0.9.0.0',
            },
            {
              type: 'section',
              condition: "get('answers.adjustment.match') === 'yes'",
              children: [
                {
                  type: 'section',
                  children: [
                    {
                      id: 'adjustment.incident',
                      type: 'binary',
                      version: '1',
                      validations: {
                        required: true,
                      },
                      label:
                        'Jag har under den senaste 3-månadersperioden utsatts för en eller flera negativa livshändelser: sorg, sociala kränkningar, olyckor etc. Händelsen har fått mig att må dåligt.',
                      index: '0.9.0.1.0.0',
                    },
                    {
                      id: 'adjustment.strain',
                      type: 'binary',
                      version: '1',
                      validations: {
                        required: true,
                      },
                      label:
                        'Jag har varit utsatt för stress utöver det vanliga i arbetet/studierna, i min närmiljö eller i min familj. Detta har fått mig att må dåligt.',
                      index: '0.9.0.1.0.1',
                    },
                  ],
                  version: '1',
                  index: '0.9.0.1.0',
                },
                {
                  type: 'section',
                  condition:
                    "get('answers.adjustment.incident') === 'yes' || get('answers.adjustment.strain') === 'yes'",
                  children: [
                    {
                      type: 'section',
                      children: [
                        {
                          id: 'adjustment.status',
                          type: 'composite',
                          version: '2',
                          children: [
                            {
                              id: 'adjustment.status.depressed',
                              type: 'choice',
                              options: [
                                {
                                  value: 0,
                                  label: 'Inte alls nedstämd',
                                },
                                {
                                  value: 1,
                                  label: 'Lite nedstämd',
                                },
                                {
                                  value: 2,
                                  label: 'Tämligen nedstämd',
                                },
                                {
                                  value: 3,
                                  label: 'Mycket nedstämd',
                                },
                              ],
                              relativeId: 'depressed',
                              version: '2',
                              validations: {
                                required: true,
                              },
                              label:
                                'Hur nedstämd och deprimerad känner du dig?',
                              description:
                                'Markera hur du har det och har haft det under de senaste två veckorna.',
                              index: '0.9.0.1.1.0.0.0',
                            },
                            {
                              id: 'adjustment.status.lackOfJoy',
                              type: 'choice',
                              options: [
                                {
                                  value: 0,
                                  label: 'Nej, inte alls',
                                },
                                {
                                  value: 1,
                                  label: 'Ja, lite grann',
                                },
                                {
                                  value: 2,
                                  label: 'Ja, en hel del',
                                },
                                {
                                  value: 3,
                                  label: 'Ja, mycket',
                                },
                              ],
                              relativeId: 'lackOfJoy',
                              version: '2',
                              validations: {
                                required: true,
                              },
                              label:
                                'Känns det som om du saknar lust och glädje i det du gör?',
                              description:
                                'Markera hur du har det och har haft det under de senaste två veckorna.',
                              index: '0.9.0.1.1.0.0.1',
                            },
                            {
                              id: 'adjustment.status.reclusive',
                              type: 'choice',
                              options: [
                                {
                                  value: 0,
                                  label: 'Nej, inte alls',
                                },
                                {
                                  value: 1,
                                  label: 'Ja, lite grann',
                                },
                                {
                                  value: 2,
                                  label: 'Ja, en hel del',
                                },
                                {
                                  value: 3,
                                  label: 'Ja, mycket',
                                },
                              ],
                              relativeId: 'reclusive',
                              version: '2',
                              validations: {
                                required: true,
                              },
                              label:
                                'Har du tappat intresset för dina vänner/bekanta och dina fritidsaktiviteter och dragit dig undan sociala kontakter?',
                              description:
                                'Markera hur du har det och har haft det under de senaste två veckorna.',
                              index: '0.9.0.1.1.0.0.2',
                            },
                            {
                              id: 'adjustment.status.worriedAnxiousTense',
                              type: 'choice',
                              options: [
                                {
                                  value: 0,
                                  label: 'Nej, inte alls',
                                },
                                {
                                  value: 1,
                                  label: 'Ja, lite grann',
                                },
                                {
                                  value: 2,
                                  label: 'Ja, en hel del',
                                },
                                {
                                  value: 3,
                                  label: 'Ja, mycket',
                                },
                              ],
                              relativeId: 'worriedAnxiousTense',
                              version: '2',
                              validations: {
                                required: true,
                              },
                              label:
                                'Känner du dig orolig, ångestfylld och spänd?',
                              description:
                                'Markera hur du har det och har haft det under de senaste två veckorna.',
                              index: '0.9.0.1.1.0.0.3',
                            },
                            {
                              id: 'adjustment.status.worried',
                              type: 'choice',
                              options: [
                                {
                                  value: 0,
                                  label: 'Nej, inte alls',
                                },
                                {
                                  value: 1,
                                  label: 'Ja, lite grann',
                                },
                                {
                                  value: 2,
                                  label: 'Ja, en hel del',
                                },
                                {
                                  value: 3,
                                  label: 'Ja, mycket',
                                },
                              ],
                              relativeId: 'worried',
                              version: '2',
                              validations: {
                                required: true,
                              },
                              label:
                                'Oroar du dig för saker du egentligen inte borde oroa dig för?',
                              description:
                                'Markera hur du har det och har haft det under de senaste två veckorna.',
                              index: '0.9.0.1.1.0.0.4',
                            },
                            {
                              id: 'adjustment.status.heartbeatSweating',
                              type: 'choice',
                              options: [
                                {
                                  value: 0,
                                  label: 'Nej, inte alls',
                                },
                                {
                                  value: 1,
                                  label: 'Ja, lite grann',
                                },
                                {
                                  value: 2,
                                  label: 'Ja, en hel del',
                                },
                                {
                                  value: 3,
                                  label: 'Ja, mycket',
                                },
                              ],
                              relativeId: 'heartbeatSweating',
                              version: '2',
                              validations: {
                                required: true,
                              },
                              label:
                                'Slår hjärtat fort och hårt ibland, kan du bli kall och svettig om händer och fötter, och behöva gå på toaletten oftare än vanligt?',
                              description:
                                'Markera hur du har det och har haft det under de senaste två veckorna.',
                              index: '0.9.0.1.1.0.0.5',
                            },
                            {
                              id: 'adjustment.status.concentration',
                              type: 'choice',
                              options: [
                                {
                                  value: 0,
                                  label: 'Nej, inte alls',
                                },
                                {
                                  value: 1,
                                  label: 'Ja, lite grann',
                                },
                                {
                                  value: 2,
                                  label: 'Ja, en hel del',
                                },
                                {
                                  value: 3,
                                  label: 'Ja, mycket',
                                },
                              ],
                              relativeId: 'concentration',
                              version: '2',
                              validations: {
                                required: true,
                              },
                              label:
                                'Har du svårt att koncentrera dig och känner att du “tappar tråden”?',
                              description:
                                'Markera hur du har det och har haft det under de senaste två veckorna.',
                              index: '0.9.0.1.1.0.0.6',
                            },
                            {
                              id: 'adjustment.status.troubleFallingAsleep',
                              type: 'choice',
                              options: [
                                {
                                  value: 0,
                                  label: 'Nej',
                                },
                                {
                                  value: 1,
                                  label: 'Ja, ungefär hälften av nätterna',
                                },
                                {
                                  value: 2,
                                  label: 'Ja, varje natt',
                                },
                              ],
                              relativeId: 'troubleFallingAsleep',
                              version: '2',
                              validations: {
                                required: true,
                              },
                              label: 'Har du svårt att somna?',
                              description:
                                'Markera hur du har det och har haft det under de senaste två veckorna.',
                              index: '0.9.0.1.1.0.0.7',
                            },
                            {
                              id: 'adjustment.status.troubleSleeping',
                              type: 'choice',
                              options: [
                                {
                                  value: 0,
                                  label: 'Nej',
                                },
                                {
                                  value: 1,
                                  label: 'Ja, ungefär hälften av nätterna',
                                },
                                {
                                  value: 2,
                                  label: 'Ja, alla nätter',
                                },
                              ],
                              relativeId: 'troubleSleeping',
                              version: '2',
                              validations: {
                                required: true,
                              },
                              label: 'Sover du oroligt?',
                              description:
                                'Markera hur du har det och har haft det under de senaste två veckorna.',
                              index: '0.9.0.1.1.0.0.8',
                            },
                            {
                              id: 'adjustment.status.wakeUpRested',
                              type: 'choice',
                              options: [
                                {
                                  value: 0,
                                  label: 'Ja',
                                },
                                {
                                  value: 1,
                                  label: 'Ja, men bara ca hälften av morgnarna',
                                },
                                {
                                  value: 2,
                                  label: 'Nej, jag känner mig sällan utsövd',
                                },
                              ],
                              relativeId: 'wakeUpRested',
                              version: '2',
                              validations: {
                                required: true,
                              },
                              label: 'Känner du dig utsövd när du vaknar?',
                              description:
                                'Markera hur du har det och har haft det under de senaste två veckorna.',
                              index: '0.9.0.1.1.0.0.9',
                            },
                          ],
                          extras: {},
                          index: '0.9.0.1.1.0.0',
                        },
                      ],
                      version: '1',
                      index: '0.9.0.1.1.0',
                    },
                    {
                      type: 'section',
                      children: [
                        {
                          id: 'adjustment.affected',
                          type: 'range',
                          version: '1',
                          min: {
                            value: 0,
                            label: 'Inte alls',
                          },
                          max: {
                            value: 20,
                            label: 'Extremt mycket',
                          },
                          extras: {
                            vas: true,
                            invert: false,
                          },
                          validations: {
                            required: true,
                          },
                          label:
                            'Du har nu besvarat ett antal frågor om besvär orsakade av stress. Hur mycket påverkas ditt välbefinnande av den typen av problem? Markera på skalan.',
                          index: '0.9.0.1.1.1.0',
                        },
                        {
                          id: 'adjustment.social',
                          type: 'range',
                          version: '1',
                          min: {
                            value: 0,
                            label: 'Inte alls',
                          },
                          max: {
                            value: 20,
                            label: 'Extremt mycket',
                          },
                          extras: {
                            vas: true,
                            invert: false,
                          },
                          validations: {
                            required: true,
                          },
                          label:
                            'Hur mycket begränsar sådana problem dig i sociala sammanhang? Markera på skalan.',
                          index: '0.9.0.1.1.1.1',
                        },
                      ],
                      version: '1',
                      index: '0.9.0.1.1.1',
                    },
                  ],
                  version: '1',
                  index: '0.9.0.1.1',
                },
              ],
              version: '1',
              index: '0.9.0.1',
            },
          ],
          version: '1',
          index: '0.9.0',
        },
        {
          type: 'section',
          children: [
            {
              type: 'section',
              children: [
                {
                  id: 'depression.match',
                  type: 'choice',
                  options: [
                    {
                      value: 'yes',
                      label:
                        'Jag har en sådan period nu som varat längre än två veckor',
                    },
                    {
                      value: 'previously',
                      label:
                        'Jag har haft sådana episoder tidigare men inte nu',
                    },
                    {
                      value: 'no',
                      label:
                        'Jag har inte haft sådana problem, varken nu eller tidigare',
                    },
                  ],
                  version: '1',
                  validations: {
                    required: true,
                  },
                  description:
                    '  Perioder när man känner sig nedstämd och ledsen är vanliga utan att detta är en sjukdom. Om sådana perioder varar längre än några veckor, om det inte finns någon begriplig anledning och om man fungerar klart sämre än vanligt kan man behöva behandling. Om nedstämdheten är svår och särskilt om man funderar över meningen med sitt liv ska man söka hjälp.',
                  index: '0.9.1.0.0',
                },
              ],
              index: '0.9.1.0',
            },
            {
              type: 'section',
              condition: "get('answers.depression.match') === 'yes'",
              children: [
                {
                  id: 'depression.status',
                  type: 'composite',
                  version: '2',
                  children: [
                    {
                      id: 'depression.status.amount',
                      type: 'choice',
                      options: [
                        {
                          value: 0,
                          label: 'Inte alls nedstämd',
                        },
                        {
                          value: 1,
                          label: 'Lite nedstämd',
                        },
                        {
                          value: 2,
                          label: 'Tämligen nedstämd',
                        },
                        {
                          value: 3,
                          label: 'Mycket nedstämd',
                        },
                        {
                          value: 4,
                          label: 'Extremt nedstämd',
                        },
                      ],
                      relativeId: 'amount',
                      version: '2',
                      validations: {
                        required: true,
                      },
                      label: 'Hur nedstämd och deprimerad känner du dig?',
                      description:
                        'Markera hur du har det och har haft det under de senaste två veckorna.',
                      index: '0.9.1.1.0.0',
                    },
                    {
                      id: 'depression.status.lackOfJoy',
                      type: 'choice',
                      options: [
                        {
                          value: 0,
                          label: 'Nej, inte alls',
                        },
                        {
                          value: 1,
                          label: 'Ja, lite grann',
                        },
                        {
                          value: 2,
                          label: 'Ja, en hel del',
                        },
                        {
                          value: 3,
                          label: 'Ja, mycket',
                        },
                        {
                          value: 4,
                          label: 'Ja, i extrem grad',
                        },
                      ],
                      relativeId: 'lackOfJoy',
                      version: '2',
                      validations: {
                        required: true,
                      },
                      label:
                        'Känns det som om du saknar lust och glädje i det du gör?',
                      description:
                        'Markera hur du har det och har haft det under de senaste två veckorna.',
                      index: '0.9.1.1.0.1',
                    },
                    {
                      id: 'depression.status.noInterestInFriendsAndHobbies',
                      type: 'choice',
                      options: [
                        {
                          value: 0,
                          label: 'Nej, inte alls',
                        },
                        {
                          value: 1,
                          label: 'Ja, lite grann',
                        },
                        {
                          value: 2,
                          label: 'Ja, en hel del',
                        },
                        {
                          value: 3,
                          label: 'Ja, mycket',
                        },
                        {
                          value: 4,
                          label: 'Ja, i extrem grad',
                        },
                      ],
                      relativeId: 'noInterestInFriendsAndHobbies',
                      version: '2',
                      validations: {
                        required: true,
                      },
                      label:
                        'Har du tappat intresset för dina vänner/bekanta och dina fritidsaktiviteter?',
                      description:
                        'Markera hur du har det och har haft det under de senaste två veckorna.',
                      index: '0.9.1.1.0.2',
                    },
                    {
                      id: 'depression.status.darkFuture',
                      type: 'choice',
                      options: [
                        {
                          value: 0,
                          label: 'Nej, inte alls',
                        },
                        {
                          value: 1,
                          label: 'Ja, lite grann',
                        },
                        {
                          value: 2,
                          label: 'Ja, en hel del',
                        },
                        {
                          value: 3,
                          label: 'Ja, mycket',
                        },
                        {
                          value: 4,
                          label: 'Ja, i extrem grad',
                        },
                      ],
                      relativeId: 'darkFuture',
                      version: '2',
                      validations: {
                        required: true,
                      },
                      label: 'Känns framtiden mörk och utan hopp om bättring?',
                      description:
                        'Markera hur du har det och har haft det under de senaste två veckorna.',
                      index: '0.9.1.1.0.3',
                    },
                    {
                      id: 'depression.status.meaningless',
                      type: 'choice',
                      options: [
                        {
                          value: 0,
                          label: 'Nej',
                        },
                        {
                          value: 1,
                          label: 'Ja, ganska meningslöst',
                        },
                        {
                          value: 2,
                          label: 'Ja, helt meningslöst',
                        },
                      ],
                      relativeId: 'meaningless',
                      version: '2',
                      validations: {
                        required: true,
                      },
                      label: 'Tycker du att livet är meningslöst just nu?',
                      description:
                        'Markera hur du har det och har haft det under de senaste två veckorna.',
                      index: '0.9.1.1.0.4',
                    },
                    {
                      id: 'depression.status.thoughtsOfNotLiving',
                      type: 'choice',
                      condition:
                        "get('answers.depression.status.meaningless') > 0",
                      options: [
                        {
                          value: 0,
                          label: 'Nej, inte alls',
                        },
                        {
                          value: 1,
                          label: 'Ja, någon enstaka gång',
                        },
                        {
                          value: 2,
                          label: 'Ja, relativt ofta',
                        },
                        {
                          value: 3,
                          label: 'Ja, större delen av tiden',
                        },
                      ],
                      relativeId: 'thoughtsOfNotLiving',
                      version: '2',
                      validations: {
                        required: true,
                      },
                      label:
                        'Förekommer det att du tänker att det vore bättre om du inte levde?',
                      description:
                        'Markera hur du har det och har haft det under de senaste två veckorna.',
                      index: '0.9.1.1.0.5',
                    },
                    {
                      id: 'depression.status.suicidal',
                      type: 'choice',
                      condition:
                        "get('answers.depression.status.meaningless') > 0",
                      options: [
                        {
                          value: 0,
                          label: 'Nej',
                        },
                        {
                          value: 1,
                          label: 'Kanske',
                        },
                        {
                          value: 2,
                          label: 'Ja',
                        },
                      ],
                      relativeId: 'suicidal',
                      version: '2',
                      validations: {
                        required: true,
                      },
                      label:
                        'Tror du att du kommer att försöka att ta ditt liv i framtiden?',
                      description:
                        'Markera hur du har det och har haft det under de senaste två veckorna.',
                      index: '0.9.1.1.0.6',
                    },
                    {
                      id: 'depression.status.guilt',
                      type: 'choice',
                      options: [
                        {
                          value: 0,
                          label: 'Nej',
                        },
                        {
                          value: 1,
                          label: 'Ibland',
                        },
                        {
                          value: 2,
                          label: 'Hela tiden',
                        },
                      ],
                      relativeId: 'guilt',
                      version: '2',
                      validations: {
                        required: true,
                      },
                      label:
                        'Har du skuldkänslor för saker som du gjort eller tankar du har tänkt?',
                      description:
                        'Markera hur du har det och har haft det under de senaste två veckorna.',
                      index: '0.9.1.1.0.7',
                    },
                    {
                      id: 'depression.status.worriedAnxiousTense',
                      type: 'choice',
                      options: [
                        {
                          value: 0,
                          label: 'Nej, inte alls',
                        },
                        {
                          value: 1,
                          label: 'Ja, lite grann',
                        },
                        {
                          value: 2,
                          label: 'Ja, en hel del',
                        },
                        {
                          value: 3,
                          label: 'Ja, mycket',
                        },
                        {
                          value: 4,
                          label: 'Ja, i extrem grad',
                        },
                      ],
                      relativeId: 'worriedAnxiousTense',
                      version: '2',
                      validations: {
                        required: true,
                      },
                      label: 'Känner du dig orolig, ångestfylld och spänd?',
                      description:
                        'Markera hur du har det och har haft det under de senaste två veckorna.',
                      index: '0.9.1.1.0.8',
                    },
                    {
                      id: 'depression.status.seriousDisease',
                      type: 'choice',
                      options: [
                        {
                          value: 0,
                          label: 'Nej, inte alls',
                        },
                        {
                          value: 1,
                          label: 'Ja, lite grann',
                        },
                        {
                          value: 2,
                          label: 'Ja, en hel del',
                        },
                        {
                          value: 3,
                          label: 'Ja, mycket',
                        },
                        {
                          value: 4,
                          label: 'Ja, i extrem grad',
                        },
                      ],
                      relativeId: 'seriousDisease',
                      version: '2',
                      validations: {
                        required: true,
                      },
                      label:
                        'Oroar du dig för att du kanske har en allvarlig sjukdom som cancer, HIV/AIDS och liknande?',
                      description:
                        'Markera hur du har det och har haft det under de senaste två veckorna.',
                      index: '0.9.1.1.0.9',
                    },
                    {
                      id: 'depression.status.disconnected',
                      type: 'choice',
                      options: [
                        {
                          value: 0,
                          label: 'Nej, inte alls',
                        },
                        {
                          value: 1,
                          label: 'Ja, lite grann',
                        },
                        {
                          value: 2,
                          label: 'Ja, en hel del',
                        },
                        {
                          value: 3,
                          label: 'Ja, mycket',
                        },
                        {
                          value: 4,
                          label: 'Ja, i extrem grad',
                        },
                      ],
                      relativeId: 'disconnected',
                      version: '2',
                      validations: {
                        required: true,
                      },
                      label:
                        'Känns det ibland som om du själv eller världen omkring dig är avlägsen och overklig?',
                      description:
                        'Markera hur du har det och har haft det under de senaste två veckorna.',
                      index: '0.9.1.1.0.10',
                    },
                  ],
                  extras: {},
                  index: '0.9.1.1.0',
                },
              ],
              version: '1',
              index: '0.9.1.1',
            },
            {
              type: 'section',
              condition: "get('answers.depression.match') === 'yes'",
              children: [
                {
                  id: 'depression.history',
                  type: 'composite',
                  version: '1',
                  children: [
                    {
                      id: 'depression.history.episodes',
                      type: 'choice',
                      options: [
                        {
                          value: 0,
                          label: 'Nej, aldrig',
                        },
                        {
                          value: 1,
                          label: 'Ja, minst en gång',
                        },
                        {
                          value: 2,
                          label: 'Ja, minst tre gånger',
                        },
                        {
                          value: 3,
                          label: 'Många gånger',
                        },
                      ],
                      relativeId: 'episodes',
                      version: '1',
                      validations: {
                        required: true,
                      },
                      label:
                        'Om du ser tillbaka på ditt vuxna liv, har du under någon period varit djupt deprimerad, dvs känt dig mycket nedstämd, inte kunnat glädjas åt något, förlorat intresset för det mesta (studier/arbete, vänner, fritidsintressen etc)?',
                      index: '0.9.1.2.0.0',
                    },
                    {
                      id: 'depression.history.suicidal',
                      type: 'choice',
                      condition:
                        "get('answers.depression.history.episodes') > 0",
                      options: [
                        {
                          value: 0,
                          label: 'Nej',
                        },
                        {
                          value: 1,
                          label: 'Ja, någon enstaka gång',
                        },
                        {
                          value: 2,
                          label: 'Ja, vid upprepade tillfällen',
                        },
                      ],
                      relativeId: 'suicidal',
                      version: '1',
                      validations: {
                        required: true,
                      },
                      label:
                        'Övervägde du att ta ditt liv under någon av dessa perioder?',
                      index: '0.9.1.2.0.1',
                    },
                    {
                      id: 'depression.history.suicideAttempts',
                      type: 'choice',
                      condition:
                        "get('answers.depression.history.episodes') > 0 && get('answers.depression.history.suicidal') > 0",
                      options: [
                        {
                          value: 0,
                          label: 'Nej',
                        },
                        {
                          value: 1,
                          label: 'Ja, någon enstaka gång',
                        },
                        {
                          value: 2,
                          label: 'Ja, vid upprepade tillfällen',
                        },
                      ],
                      relativeId: 'suicideAttempts',
                      version: '1',
                      validations: {
                        required: true,
                      },
                      label:
                        'Gjorde du faktiskt försök att ta ditt liv under någon av dessa perioder?',
                      index: '0.9.1.2.0.2',
                    },
                    {
                      id: 'depression.history.passiveHarm',
                      type: 'choice',
                      condition:
                        "get('answers.depression.history.episodes') > 0",
                      options: [
                        {
                          value: 0,
                          label: 'Nej',
                        },
                        {
                          value: 1,
                          label: 'Ja, någon enstaka gång',
                        },
                        {
                          value: 2,
                          label: 'Ja, vid upprepade tillfällen',
                        },
                      ],
                      relativeId: 'passiveHarm',
                      version: '1',
                      validations: {
                        required: true,
                      },
                      label:
                        'Hände det att du skadade dig själv passivt, t.ex. genom att försumma din hälsa, ta risker eller genom självdestruktivt missbruk?',
                      index: '0.9.1.2.0.3',
                    },
                  ],
                  extras: {},
                  index: '0.9.1.2.0',
                },
              ],
              version: '1',
              index: '0.9.1.2',
            },
            {
              type: 'section',
              condition: "get('answers.depression.match') === 'yes'",
              children: [
                {
                  id: 'depression.affected',
                  type: 'range',
                  version: '1',
                  min: {
                    value: 0,
                    label: 'Inte alls',
                  },
                  max: {
                    value: 20,
                    label: 'Extremt mycket',
                  },
                  extras: {
                    vas: true,
                    invert: false,
                  },
                  validations: {
                    required: true,
                  },
                  label:
                    'Hur mycket störs ditt välbefinnande av din nedstämdhet? Markera på skalan.',
                  index: '0.9.1.3.0',
                },
                {
                  id: 'depression.social',
                  type: 'range',
                  version: '1',
                  min: {
                    value: 0,
                    label: 'Inte alls',
                  },
                  max: {
                    value: 20,
                    label: 'Extremt mycket',
                  },
                  extras: {
                    vas: true,
                    invert: false,
                  },
                  validations: {
                    required: true,
                  },
                  label:
                    'Hur mycket har din nedstämdhet påverkat dina sociala aktiviteter? Markera på skalan.',
                  index: '0.9.1.3.1',
                },
              ],
              version: '1',
              index: '0.9.1.3',
            },
            {
              type: 'section',
              condition: "get('answers.depression.match') === 'yes'",
              children: [
                {
                  type: 'section',
                  children: [
                    {
                      id: 'dysthymia.match',
                      type: 'choice',
                      version: '1',
                      options: [
                        {
                          value: 'no',
                          label: 'Nej',
                        },
                        {
                          value: 'yes',
                          label: 'Ja',
                        },
                      ],
                      validations: {
                        required: true,
                      },
                      label:
                        'Har du varit nedstämd mer eller mindre ständigt under de senaste två åren?',
                      index: '0.9.1.4.0.0',
                    },
                  ],
                  index: '0.9.1.4.0',
                },
                {
                  type: 'section',
                  condition: "get('answers.dysthymia.match') === 'yes'",
                  children: [
                    {
                      type: 'section',
                      children: [
                        {
                          id: 'dysthymia.status',
                          type: 'composite',
                          version: '2',
                          children: [
                            {
                              id: 'dysthymia.status.appetiteIssues',
                              type: 'binary',
                              relativeId: 'appetiteIssues',
                              version: '2',
                              validations: {
                                required: true,
                              },
                              label:
                                'Har du haft dåligt aptit, eller ätit för mycket (tröstätit) under de senaste två åren?',
                              index: '0.9.1.4.1.0.0.0',
                            },
                            {
                              id: 'dysthymia.status.sleepIssues',
                              type: 'binary',
                              relativeId: 'sleepIssues',
                              version: '2',
                              validations: {
                                required: true,
                              },
                              label:
                                'Har du haft sömnproblem så att du antingen har fått för lite sömn eller sovit för mycket (sovit bort tid) under de senaste två åren?',
                              index: '0.9.1.4.1.0.0.1',
                            },
                            {
                              id: 'dysthymia.status.lowEnergy',
                              type: 'binary',
                              relativeId: 'lowEnergy',
                              version: '2',
                              validations: {
                                required: true,
                              },
                              label:
                                'Har du känt dig orkeslös och svag (saknat energi) under de senaste två åren?',
                              index: '0.9.1.4.1.0.0.2',
                            },
                            {
                              id: 'dysthymia.status.lowSelfEsteem',
                              type: 'binary',
                              relativeId: 'lowSelfEsteem',
                              version: '2',
                              validations: {
                                required: true,
                              },
                              label:
                                'Har din självkänsla varit låg, lägre än den borde vara, under de senaste två åren?',
                              index: '0.9.1.4.1.0.0.3',
                            },
                            {
                              id: 'dysthymia.status.hardToConcentrate',
                              type: 'binary',
                              relativeId: 'hardToConcentrate',
                              version: '2',
                              validations: {
                                required: true,
                              },
                              label:
                                'Har du haft svårt att koncentrera dig, fokusera och fatta beslut under de senaste två åren?',
                              index: '0.9.1.4.1.0.0.4',
                            },
                            {
                              id: 'dysthymia.status.hopeless',
                              type: 'binary',
                              relativeId: 'hopeless',
                              version: '2',
                              validations: {
                                required: true,
                              },
                              label:
                                'Har det känts hopplöst och att ingen bättring kan förväntas under de senaste två åren?',
                              index: '0.9.1.4.1.0.0.5',
                            },
                            {
                              id: 'dysthymia.status.recurring',
                              type: 'binary',
                              relativeId: 'recurring',
                              version: '2',
                              validations: {
                                required: true,
                              },
                              label:
                                'I den mån det har varit bättre under de två åren har mina besvär återkommit senast efter 2 månader.',
                              index: '0.9.1.4.1.0.0.6',
                            },
                          ],
                          extras: {},
                          index: '0.9.1.4.1.0.0',
                        },
                      ],
                      index: '0.9.1.4.1.0',
                    },
                    {
                      type: 'section',
                      children: [
                        {
                          id: 'dysthymia.affected',
                          type: 'range',
                          version: '1',
                          min: {
                            value: 0,
                            label: 'Inte alls',
                          },
                          max: {
                            value: 20,
                            label: 'Extremt mycket',
                          },
                          extras: {
                            vas: true,
                            invert: false,
                          },
                          validations: {
                            required: true,
                          },
                          label:
                            'Hur mycket har ditt välbefinnande störts av denna typ av långdragna depressionssymptom? Markera på skalan.',
                          index: '0.9.1.4.1.1.0',
                        },
                        {
                          id: 'dysthymia.social',
                          type: 'range',
                          version: '1',
                          min: {
                            value: 0,
                            label: 'Inte alls',
                          },
                          max: {
                            value: 20,
                            label: 'Extremt mycket',
                          },
                          extras: {
                            vas: true,
                            invert: false,
                          },
                          validations: {
                            required: true,
                          },
                          label:
                            'Hur mycket har sådana symptom påverkat dina sociala aktiviteter? Markera på skalan.',
                          index: '0.9.1.4.1.1.1',
                        },
                      ],
                      version: '1',
                      index: '0.9.1.4.1.1',
                    },
                  ],
                  version: '1',
                  index: '0.9.1.4.1',
                },
              ],
              version: '1',
              index: '0.9.1.4',
            },
          ],
          version: '1',
          index: '0.9.1',
        },
        {
          type: 'section',
          children: [
            {
              type: 'section',
              children: [
                {
                  id: 'gad.match',
                  type: 'choice',
                  options: [
                    {
                      value: 'yes',
                      label: 'Jag har nog sådana problem just nu.',
                    },
                    {
                      value: 'previously',
                      label:
                        'Jag har haft sådana problem tidigare men inte nu.',
                    },
                    {
                      value: 'no',
                      label: 'Jag har inte haft sådana problem tidigare.',
                    },
                  ],
                  version: '1',
                  validations: {
                    required: true,
                  },
                  description:
                    '  En särskild form av ångest är att man oroar sig för många olika vardagliga situationer, som andra inte oroar sig för (att bilen går sönder, att komma för sent till ett möte etc). Man kan inte "stänga av" oron, känner sig spänd, irritabel och uttröttad, kan inte koncentrera sig och sover dåligt. Problemen har funnits under lång tid och de flesta dagarna under den tiden är "dåliga".',
                  index: '0.9.2.0.0',
                },
              ],
              index: '0.9.2.0',
            },
            {
              type: 'section',
              condition: "get('answers.gad.match') === 'yes'",
              children: [
                {
                  type: 'section',
                  children: [
                    {
                      id: 'gad.status',
                      type: 'composite',
                      version: '2',
                      children: [
                        {
                          id: 'gad.status.ache',
                          type: 'choice',
                          options: [
                            {
                              value: 0,
                              label: 'Stämmer inte alls',
                            },
                            {
                              value: 1,
                              label: 'Stämmer lite grann',
                            },
                            {
                              value: 2,
                              label: 'Stämmer ganska väl',
                            },
                            {
                              value: 3,
                              label: 'Stämmer mycket väl',
                            },
                          ],
                          relativeId: 'ache',
                          version: '2',
                          validations: {
                            required: true,
                          },
                          label: 'Jag får ofta värk i nacke och axlar.',
                          description:
                            'Välj det påstående som bäst motsvarar hur det varit under det senaste året.',
                          index: '0.9.2.1.0.0.0',
                        },
                        {
                          id: 'gad.status.tired',
                          type: 'choice',
                          options: [
                            {
                              value: 0,
                              label: 'Stämmer inte alls',
                            },
                            {
                              value: 1,
                              label: 'Stämmer lite grann',
                            },
                            {
                              value: 2,
                              label: 'Stämmer ganska väl',
                            },
                            {
                              value: 3,
                              label: 'Stämmer mycket väl',
                            },
                          ],
                          relativeId: 'tired',
                          version: '2',
                          validations: {
                            required: true,
                          },
                          label:
                            'Jag har alltför lätt att bli trött och jäktad.',
                          description:
                            'Välj det påstående som bäst motsvarar hur det varit under det senaste året.',
                          index: '0.9.2.1.0.0.1',
                        },
                        {
                          id: 'gad.status.lowSelfEsteem',
                          type: 'choice',
                          options: [
                            {
                              value: 0,
                              label: 'Stämmer inte alls',
                            },
                            {
                              value: 1,
                              label: 'Stämmer lite grann',
                            },
                            {
                              value: 2,
                              label: 'Stämmer ganska väl',
                            },
                            {
                              value: 3,
                              label: 'Stämmer mycket väl',
                            },
                          ],
                          relativeId: 'lowSelfEsteem',
                          version: '2',
                          validations: {
                            required: true,
                          },
                          label: 'Jag har ganska dåligt självförtroende.',
                          description:
                            'Välj det påstående som bäst motsvarar hur det varit under det senaste året.',
                          index: '0.9.2.1.0.0.2',
                        },
                        {
                          id: 'gad.status.tense',
                          type: 'choice',
                          options: [
                            {
                              value: 0,
                              label: 'Stämmer inte alls',
                            },
                            {
                              value: 1,
                              label: 'Stämmer lite grann',
                            },
                            {
                              value: 2,
                              label: 'Stämmer ganska väl',
                            },
                            {
                              value: 3,
                              label: 'Stämmer mycket väl',
                            },
                          ],
                          relativeId: 'tense',
                          version: '2',
                          validations: {
                            required: true,
                          },
                          label:
                            'Jag känner mig ofta stel och spänd i kroppen.',
                          description:
                            'Välj det påstående som bäst motsvarar hur det varit under det senaste året.',
                          index: '0.9.2.1.0.0.3',
                        },
                        {
                          id: 'gad.status.sensitive',
                          type: 'choice',
                          options: [
                            {
                              value: 0,
                              label: 'Stämmer inte alls',
                            },
                            {
                              value: 1,
                              label: 'Stämmer lite grann',
                            },
                            {
                              value: 2,
                              label: 'Stämmer ganska väl',
                            },
                            {
                              value: 3,
                              label: 'Stämmer mycket väl',
                            },
                          ],
                          relativeId: 'sensitive',
                          version: '2',
                          validations: {
                            required: true,
                          },
                          label:
                            'Jag hör nog till den sortens människor som är överdrivet känsliga och tar åt sig för det minsta.',
                          description:
                            'Välj det påstående som bäst motsvarar hur det varit under det senaste året.',
                          index: '0.9.2.1.0.0.4',
                        },
                        {
                          id: 'gad.status.hardToOvercome',
                          type: 'choice',
                          options: [
                            {
                              value: 0,
                              label: 'Stämmer inte alls',
                            },
                            {
                              value: 1,
                              label: 'Stämmer lite grann',
                            },
                            {
                              value: 2,
                              label: 'Stämmer ganska väl',
                            },
                            {
                              value: 3,
                              label: 'Stämmer mycket väl',
                            },
                          ],
                          relativeId: 'hardToOvercome',
                          version: '2',
                          validations: {
                            required: true,
                          },
                          label:
                            'Det tar nog ovanligt lång tid för mig att komma över obehagliga upplevelser.',
                          description:
                            'Välj det påstående som bäst motsvarar hur det varit under det senaste året.',
                          index: '0.9.2.1.0.0.5',
                        },
                        {
                          id: 'gad.status.stressed',
                          type: 'choice',
                          options: [
                            {
                              value: 0,
                              label: 'Stämmer inte alls',
                            },
                            {
                              value: 1,
                              label: 'Stämmer lite grann',
                            },
                            {
                              value: 2,
                              label: 'Stämmer ganska väl',
                            },
                            {
                              value: 3,
                              label: 'Stämmer mycket väl',
                            },
                          ],
                          relativeId: 'stressed',
                          version: '2',
                          validations: {
                            required: true,
                          },
                          label:
                            'Jag blir lätt stressad när jag uppmanas skynda på med ett arbete.',
                          description:
                            'Välj det påstående som bäst motsvarar hur det varit under det senaste året.',
                          index: '0.9.2.1.0.0.6',
                        },
                        {
                          id: 'gad.status.worried',
                          type: 'choice',
                          options: [
                            {
                              value: 0,
                              label: 'Stämmer inte alls',
                            },
                            {
                              value: 1,
                              label: 'Stämmer lite grann',
                            },
                            {
                              value: 2,
                              label: 'Stämmer ganska väl',
                            },
                            {
                              value: 3,
                              label: 'Stämmer mycket väl',
                            },
                          ],
                          relativeId: 'worried',
                          version: '2',
                          validations: {
                            required: true,
                          },
                          label:
                            'Jag brukar ofta gå och oroa mig även för sådant som andra uppfattar som bagateller.',
                          description:
                            'Välj det påstående som bäst motsvarar hur det varit under det senaste året.',
                          index: '0.9.2.1.0.0.7',
                        },
                        {
                          id: 'gad.status.tenseToTired',
                          type: 'choice',
                          options: [
                            {
                              value: 0,
                              label: 'Stämmer inte alls',
                            },
                            {
                              value: 1,
                              label: 'Stämmer lite grann',
                            },
                            {
                              value: 2,
                              label: 'Stämmer ganska väl',
                            },
                            {
                              value: 3,
                              label: 'Stämmer mycket väl',
                            },
                          ],
                          relativeId: 'tenseToTired',
                          version: '2',
                          validations: {
                            required: true,
                          },
                          label:
                            'Jag spänner mig ofta så hårt att jag bli trött.',
                          description:
                            'Välj det påstående som bäst motsvarar hur det varit under det senaste året.',
                          index: '0.9.2.1.0.0.8',
                        },
                        {
                          id: 'gad.status.anxious',
                          type: 'choice',
                          options: [
                            {
                              value: 0,
                              label: 'Stämmer inte alls',
                            },
                            {
                              value: 1,
                              label: 'Stämmer lite grann',
                            },
                            {
                              value: 2,
                              label: 'Stämmer ganska väl',
                            },
                            {
                              value: 3,
                              label: 'Stämmer mycket väl',
                            },
                          ],
                          relativeId: 'anxious',
                          version: '2',
                          validations: {
                            required: true,
                          },
                          label:
                            'Jag blir ängslig långt i förväg när jag ska sätta igång med något.',
                          description:
                            'Välj det påstående som bäst motsvarar hur det varit under det senaste året.',
                          index: '0.9.2.1.0.0.9',
                        },
                        {
                          id: 'gad.status.doubt',
                          type: 'choice',
                          options: [
                            {
                              value: 0,
                              label: 'Stämmer inte alls',
                            },
                            {
                              value: 1,
                              label: 'Stämmer lite grann',
                            },
                            {
                              value: 2,
                              label: 'Stämmer ganska väl',
                            },
                            {
                              value: 3,
                              label: 'Stämmer mycket väl',
                            },
                          ],
                          relativeId: 'doubt',
                          version: '2',
                          validations: {
                            required: true,
                          },
                          label:
                            'När jag köpt något går jag ofta efteråt och oroar mig att jag valt fel.',
                          description:
                            'Välj det påstående som bäst motsvarar hur det varit under det senaste året.',
                          index: '0.9.2.1.0.0.10',
                        },
                        {
                          id: 'gad.status.fatigue',
                          type: 'choice',
                          options: [
                            {
                              value: 0,
                              label: 'Stämmer inte alls',
                            },
                            {
                              value: 1,
                              label: 'Stämmer lite grann',
                            },
                            {
                              value: 2,
                              label: 'Stämmer ganska väl',
                            },
                            {
                              value: 3,
                              label: 'Stämmer mycket väl',
                            },
                          ],
                          relativeId: 'fatigue',
                          version: '2',
                          validations: {
                            required: true,
                          },
                          label:
                            'Jag tycker att jag orkar mindre än de flesta andra i min bekantskapskrets.',
                          description:
                            'Välj det påstående som bäst motsvarar hur det varit under det senaste året.',
                          index: '0.9.2.1.0.0.11',
                        },
                      ],
                      extras: {},
                      index: '0.9.2.1.0.0',
                    },
                  ],
                  index: '0.9.2.1.0',
                },
                {
                  type: 'section',
                  children: [
                    {
                      id: 'gad.affected',
                      type: 'range',
                      version: '1',
                      min: {
                        value: 0,
                        label: 'Inte alls',
                      },
                      max: {
                        value: 20,
                        label: 'Extremt mycket',
                      },
                      extras: {
                        vas: true,
                        invert: false,
                      },
                      validations: {
                        required: true,
                      },
                      label:
                        'Hur mycket har ditt välbefinnande störts av problemen med oro och andra symptom? Markera på skalan.',
                      index: '0.9.2.1.1.0',
                    },
                    {
                      id: 'gad.social',
                      type: 'range',
                      version: '1',
                      min: {
                        value: 0,
                        label: 'Inte alls',
                      },
                      max: {
                        value: 20,
                        label: 'Extremt mycket',
                      },
                      extras: {
                        vas: true,
                        invert: false,
                      },
                      validations: {
                        required: true,
                      },
                      label:
                        'Hur mycket har sådana problem begränsat dina sociala aktiviteter? Markera på skalan.',
                      index: '0.9.2.1.1.1',
                    },
                  ],
                  version: '1',
                  index: '0.9.2.1.1',
                },
              ],
              version: '1',
              index: '0.9.2.1',
            },
          ],
          version: '1',
          index: '0.9.2',
        },
        {
          type: 'section',
          children: [
            {
              type: 'section',
              children: [
                {
                  id: 'panic.match',
                  type: 'choice',
                  options: [
                    {
                      value: 'yes',
                      label: 'Jag har nog sådana problem just nu',
                    },
                    {
                      value: 'previously',
                      label: 'Jag har haft sådana problem tidigare men inte nu',
                    },
                    {
                      value: 'no',
                      label:
                        'Jag har inte haft sådana problem tidigare och har det inte nu heller',
                    },
                  ],
                  version: '1',
                  validations: {
                    required: true,
                  },
                  description:
                    '  <p>\n    En panikattack är en snabbt påkommande skräckupplevelse kopplad till typiska förändringar i kroppsliga funktioner (hjärtat slår fort och hårt, man får inte luft, svettas, skakar och känner sig darrig). Det är normalt att reagera så när man utsätts för ett allvarligt hot, och meningsfullt för man springer fortare alternativt försvarar sig bättre. Får man plötsligt en sådan attack, utan rimlig anledning, är den meningslös och plågsam.\n  </p>\n\n  <p>\n    Isolerade panikattacker med glesa mellanrum behöver inte behandlas. Kommer de ofta brukar de få konsekvenser för en persons funktionsförmåga bl.a. därför att tre typer av funderingar aktiveras (rädsla för döden, för att bli tokig, eller "göra bort sig" socialt). Rädslan för nya attacker skapar en förhöjd ångestnivå, man känner sig otrygg om man är ensam och man undviker platser/situationer där man fått eller kan få panikattacker.\n  </p>\n\n  <p>\n    Vilket av följande påståenden stämmer bäst in på dig?\n  </p>',
                  index: '0.9.3.0.0',
                },
              ],
              index: '0.9.3.0',
            },
            {
              type: 'section',
              condition: "get('answers.panic.match') === 'yes'",
              children: [
                {
                  type: 'section',
                  children: [
                    {
                      id: 'panic.amount',
                      type: 'choice',
                      options: [
                        {
                          value: 0,
                          label: 'En panikattack',
                        },
                        {
                          value: 1,
                          label: '2-4 panikattacker',
                        },
                        {
                          value: 2,
                          label: '5-10 panikattacker',
                        },
                        {
                          value: 3,
                          label: 'Fler än 10 panikattacker',
                        },
                      ],
                      version: '1',
                      validations: {
                        required: true,
                      },
                      label:
                        'Under de senaste två månaderna har jag, utan förvarning och rimlig anledning, haft',
                      index: '0.9.3.1.0.0',
                    },
                    {
                      id: 'panic.symptoms',
                      type: 'multipleChoice',
                      options: [
                        {
                          value: 'heartbeatFasterHarder',
                          label: 'Hjärtat slår snabbt och hårt',
                        },
                        {
                          value: 'sweating',
                          label:
                            'Jag svettas, särskilt händer, fötter och armhålor',
                        },
                        {
                          value: 'tense',
                          label: 'Jag är spänd i musklerna, skakig',
                        },
                        {
                          value: 'hardToBreathe',
                          label: 'Svårt att få luft',
                        },
                        {
                          value: 'chestPain',
                          label: 'Smärta i bröstregionen',
                        },
                        {
                          value: 'unsteadinessDizziness',
                          label: 'Ostadighet, svindel',
                        },
                        {
                          value: 'numbness',
                          label: 'Känns bedövad, särskilt runt munnen',
                        },
                        {
                          value: 'bathroom',
                          label: 'Behöver gå på toaletten',
                        },
                        {
                          value: 'surreality',
                          label: 'Overklighetskänslor',
                        },
                        {
                          value: 'fearDeathCrazyControl',
                          label:
                            'Rädd att dö, bli tokig eller förlora kontrollen',
                        },
                      ],
                      validations: {
                        required: false,
                      },
                      version: '1',
                      label:
                        'Kryssa i vilka symptom du brukar uppleva under en panikattack.',
                      index: '0.9.3.1.0.1',
                    },
                    {
                      id: 'panic.afraid',
                      type: 'choice',
                      options: [
                        {
                          value: 2,
                          label: 'Stämmer precis',
                        },
                        {
                          value: 1,
                          label: 'Ja, till en del',
                        },
                        {
                          value: 0,
                          label: 'Stämmer inte',
                        },
                      ],
                      version: '1',
                      validations: {
                        required: true,
                      },
                      label:
                        'Jag är mer eller mindre ständigt rädd för att få nya panikattacker och tänker mycket på det.',
                      index: '0.9.3.1.0.2',
                    },
                    {
                      id: 'panic.avoidance',
                      type: 'choice',
                      options: [
                        {
                          value: 2,
                          label: 'Ja, definitivt',
                        },
                        {
                          value: 1,
                          label: 'Ja, en del del',
                        },
                        {
                          value: 0,
                          label: 'Nej',
                        },
                      ],
                      version: '1',
                      validations: {
                        required: true,
                      },
                      label:
                        'Jag undviker platser/situationer där jag inte vill drabbas av en attack, t.ex. varuhus, flygplatser och allmänna kommunikationsmedel.',
                      index: '0.9.3.1.0.3',
                    },
                    {
                      id: 'panic.unsafe',
                      type: 'choice',
                      options: [
                        {
                          value: 2,
                          label: 'Ja, definitivt',
                        },
                        {
                          value: 1,
                          label: 'Ja, lite grann',
                        },
                        {
                          value: 0,
                          label: 'Nej',
                        },
                      ],
                      version: '1',
                      validations: {
                        required: true,
                      },
                      label:
                        'Jag känner mig otrygg och vill kunna få hjälp av en närstående om jag får en attack. Därför vill jag ogärna vara ensam eller vill kunna nå en närstående snabbt via t.ex. mobiltelefon.',
                      index: '0.9.3.1.0.4',
                    },
                  ],
                  version: '1',
                  index: '0.9.3.1.0',
                },
                {
                  type: 'section',
                  children: [
                    {
                      id: 'panic.affected',
                      type: 'range',
                      version: '2',
                      min: {
                        value: 0,
                        label: 'Inte alls',
                      },
                      max: {
                        value: 20,
                        label: 'Extremt mycket',
                      },
                      extras: {
                        vas: true,
                        invert: false,
                      },
                      validations: {
                        required: true,
                      },
                      label:
                        'Hur mycket har ditt välbefinnande störts av panikattackerna? Markera på skalan.',
                      index: '0.9.3.1.1.0',
                    },
                    {
                      id: 'panic.social',
                      type: 'range',
                      version: '2',
                      min: {
                        value: 0,
                        label: 'Inte alls',
                      },
                      max: {
                        value: 20,
                        label: 'Extremt mycket',
                      },
                      extras: {
                        vas: true,
                        invert: false,
                      },
                      validations: {
                        required: true,
                      },
                      label:
                        'Hur mycket har panikattackerna begränsat dina sociala aktiviteter? Markera på skalan.',
                      index: '0.9.3.1.1.1',
                    },
                  ],
                  version: '1',
                  index: '0.9.3.1.1',
                },
              ],
              version: '1',
              index: '0.9.3.1',
            },
          ],
          version: '1',
          index: '0.9.3',
        },
        {
          type: 'section',
          children: [
            {
              type: 'section',
              children: [
                {
                  id: 'socialAnxiety.match',
                  type: 'choice',
                  options: [
                    {
                      value: 'yes',
                      label: 'Jag har sådana problem',
                    },
                    {
                      value: 'no',
                      label: 'Jag har inte sådana problem',
                    },
                  ],
                  version: '1',
                  validations: {
                    required: true,
                  },
                  description:
                    '  Social ångest avser rädsla och ångest för sociala situationer i vilka man\n  kan utsättas för kritisk granskning av andra personer än sådana man känner\n  väl. Rädslan/ångesten leder till att man undviker sådana situationer. Man\n  är rädd för göra bort sig bl.a. genom att rodna, tappa saker eller inte\n  kunna svara vettigt när man får frågor. Stickordet är "pinsamt".',
                  index: '0.9.4.0.0',
                },
              ],
              index: '0.9.4.0',
            },
            {
              type: 'section',
              condition: "get('answers.socialAnxiety.match') === 'yes'",
              children: [
                {
                  type: 'section',
                  children: [
                    {
                      id: 'socialAnxiety.status',
                      type: 'composite',
                      version: '2',
                      children: [
                        {
                          id: 'socialAnxiety.status.embarrassed',
                          type: 'choice',
                          options: [
                            {
                              value: 0,
                              label: 'Stämmer inte alls',
                            },
                            {
                              value: 1,
                              label: 'Stämmer lite grand',
                            },
                            {
                              value: 2,
                              label: 'Stämmer ganska bra',
                            },
                            {
                              value: 3,
                              label: 'Stämmer helt',
                            },
                          ],
                          relativeId: 'embarrassed',
                          version: '2',
                          validations: {
                            required: true,
                          },
                          label:
                            'Jag är rädd att göra bort mig när jag umgås socialt med människor jag inte känner väl.',
                          description:
                            'Välj det påstående som bäst motsvarar hur det varit under det senaste året.',
                          index: '0.9.4.1.0.0.0',
                        },
                        {
                          id: 'socialAnxiety.status.uncomfortable',
                          type: 'choice',
                          options: [
                            {
                              value: 0,
                              label: 'Stämmer inte alls',
                            },
                            {
                              value: 1,
                              label: 'Stämmer lite grand',
                            },
                            {
                              value: 2,
                              label: 'Stämmer ganska bra',
                            },
                            {
                              value: 3,
                              label: 'Stämmer helt',
                            },
                          ],
                          relativeId: 'uncomfortable',
                          version: '2',
                          validations: {
                            required: true,
                          },
                          label:
                            'Jag rodnar lätt och blir spänd och onaturlig i sociala sammanhang, och då vill jag sjunka genom golvet.',
                          description:
                            'Välj det påstående som bäst motsvarar hur det varit under det senaste året.',
                          index: '0.9.4.1.0.0.1',
                        },
                        {
                          id: 'socialAnxiety.status.fearOfBeingObserved',
                          type: 'choice',
                          options: [
                            {
                              value: 0,
                              label: 'Stämmer inte alls',
                            },
                            {
                              value: 1,
                              label: 'Stämmer lite grand',
                            },
                            {
                              value: 2,
                              label: 'Stämmer ganska bra',
                            },
                            {
                              value: 3,
                              label: 'Stämmer helt',
                            },
                          ],
                          relativeId: 'fearOfBeingObserved',
                          version: '2',
                          validations: {
                            required: true,
                          },
                          label:
                            'Jag klarar inte att göra saker när andra kan observera mig, t.ex. att äta på restaurant eller delta i aktiviteter tillsammans med obekanta.',
                          description:
                            'Välj det påstående som bäst motsvarar hur det varit under det senaste året.',
                          index: '0.9.4.1.0.0.2',
                        },
                        {
                          id: 'socialAnxiety.status.fearOfPublicSpeaking',
                          type: 'choice',
                          options: [
                            {
                              value: 0,
                              label: 'Stämmer inte alls',
                            },
                            {
                              value: 1,
                              label: 'Stämmer lite grand',
                            },
                            {
                              value: 2,
                              label: 'Stämmer ganska bra',
                            },
                            {
                              value: 3,
                              label: 'Stämmer helt',
                            },
                          ],
                          relativeId: 'fearOfPublicSpeaking',
                          version: '2',
                          validations: {
                            required: true,
                          },
                          label:
                            'Det är otänkbart för mig att hålla ett föredrag eller ett tal på en middag för personer jag inte känner.',
                          description:
                            'Välj det påstående som bäst motsvarar hur det varit under det senaste året.',
                          index: '0.9.4.1.0.0.3',
                        },
                        {
                          id: 'socialAnxiety.status.avoidance',
                          type: 'choice',
                          options: [
                            {
                              value: 0,
                              label: 'Stämmer inte alls',
                            },
                            {
                              value: 1,
                              label: 'Stämmer lite grand',
                            },
                            {
                              value: 2,
                              label: 'Stämmer ganska bra',
                            },
                            {
                              value: 3,
                              label: 'Stämmer helt',
                            },
                          ],
                          relativeId: 'avoidance',
                          version: '2',
                          validations: {
                            required: true,
                          },
                          label:
                            'Jag undviker sådana situationer trots att det innebär att jag går miste om mycket i livet.',
                          description:
                            'Välj det påstående som bäst motsvarar hur det varit under det senaste året.',
                          index: '0.9.4.1.0.0.4',
                        },
                      ],
                      extras: {},
                      index: '0.9.4.1.0.0',
                    },
                  ],
                  index: '0.9.4.1.0',
                },
                {
                  type: 'section',
                  children: [
                    {
                      id: 'socialAnxiety.affected',
                      type: 'range',
                      version: '1',
                      min: {
                        value: 0,
                        label: 'Inte alls',
                      },
                      max: {
                        value: 20,
                        label: 'Extremt mycket',
                      },
                      extras: {
                        vas: true,
                        invert: false,
                      },
                      validations: {
                        required: true,
                      },
                      label:
                        'Du har nu besvarat ett antal frågor om rädsla och ångest i sociala situationer. Hur mycket påverkas ditt välbefinnande av den typen av problem? Markera på skalan.',
                      index: '0.9.4.1.1.0',
                    },
                    {
                      id: 'socialAnxiety.social',
                      type: 'range',
                      version: '1',
                      min: {
                        value: 0,
                        label: 'Inte alls',
                      },
                      max: {
                        value: 20,
                        label: 'Extremt mycket',
                      },
                      extras: {
                        vas: true,
                        invert: false,
                      },
                      validations: {
                        required: true,
                      },
                      label:
                        'Hur mycket begränsar sådana problem dig i sociala sammanhang? Markera på skalan.',
                      index: '0.9.4.1.1.1',
                    },
                  ],
                  version: '1',
                  index: '0.9.4.1.1',
                },
              ],
              version: '1',
              index: '0.9.4.1',
            },
          ],
          version: '1',
          index: '0.9.4',
        },
        {
          type: 'section',
          children: [
            {
              type: 'section',
              children: [
                {
                  id: 'compulsion.match',
                  type: 'choice',
                  options: [
                    {
                      value: 'yes',
                      label: 'Jag har nog sådana problem',
                    },
                    {
                      value: 'no',
                      label: 'Jag har inte sådana problem',
                    },
                  ],
                  version: '1',
                  validations: {
                    required: true,
                  },
                  description:
                    '  Tvångstankar är störande tankar, känslor eller impulser som tränger sig in i medvetandet och är svåra att "stänga av". Ett sätt att bli av med dem är att utföra en tvångshandling, som vanligtvis är meningslös. Försöker man låta bli får man ångest. Det kan handla om\n  \n  <ul>\n    <li>\n      smitta/orenhet, som leder till att man tvättar sig för mycket,\n    </li>\n\n    <li>\n      att saker ska stå på ett visst sätt, rakt och symmetriskt,\n    </li>\n\n    <li>\n      rädsla för att man inte stängt av spisen och låst dörren (och man överkontrollerar detta, ofta genom att räkna kontrollåtgärderna) eller\n    </li>\n\n    <li>\n      oro för kroppslig sjukdom (hypokondri), då man söker läkare för än det ena, än det andra.\n    </li>\n  </ul>',
                  index: '0.9.5.0.0',
                },
              ],
              index: '0.9.5.0',
            },
            {
              type: 'section',
              condition: "get('answers.compulsion.match') === 'yes'",
              children: [
                {
                  type: 'section',
                  children: [
                    {
                      id: 'compulsion.status',
                      type: 'composite',
                      version: '2',
                      children: [
                        {
                          id: 'compulsion.status.dirtDiseaseBacteriaVirus',
                          type: 'choice',
                          options: [
                            {
                              value: 'now',
                              label: 'Nu',
                            },
                            {
                              value: 'previously',
                              label: 'Tidigare',
                            },
                            {
                              value: 'never',
                              label: 'Aldrig',
                            },
                          ],
                          relativeId: 'dirtDiseaseBacteriaVirus',
                          version: '2',
                          validations: {
                            required: true,
                          },
                          label:
                            'Jag oroar mig för smuts, smitta, bakterier eller virus',
                          description:
                            'Ex. Rädd för att få på sig bakterier, eller HIV/AIDS, genom att sitta på vissa stolar, säten, ta i hand eller ta på dörrhandtag.<br>Markera om du har problemet nu eller har haft det under den senaste veckan, om du har haft problemet tidigare men inte nu, eller om du aldrig har haft problemet.',
                          index: '0.9.5.1.0.0.0',
                        },
                        {
                          id: 'compulsion.status.washing',
                          type: 'choice',
                          options: [
                            {
                              value: 'now',
                              label: 'Nu',
                            },
                            {
                              value: 'previously',
                              label: 'Tidigare',
                            },
                            {
                              value: 'never',
                              label: 'Aldrig',
                            },
                          ],
                          relativeId: 'washing',
                          version: '2',
                          validations: {
                            required: true,
                          },
                          label:
                            'Jag tvättar mig överdrivet mycket eller på ett visst sätt för att slippa smitta eller föroreningar',
                          description:
                            'Ex. Tvättar händerna många gånger om dagen eller alltför länge efter att ha berört eller trott mig ha berört något förorenat eller nedsmutsat föremål.<br>Markera om du har problemet nu eller har haft det under den senaste veckan, om du har haft problemet tidigare men inte nu, eller om du aldrig har haft problemet.',
                          index: '0.9.5.1.0.0.1',
                        },
                        {
                          id: 'compulsion.status.injureOthers',
                          type: 'choice',
                          options: [
                            {
                              value: 'now',
                              label: 'Nu',
                            },
                            {
                              value: 'previously',
                              label: 'Tidigare',
                            },
                            {
                              value: 'never',
                              label: 'Aldrig',
                            },
                          ],
                          relativeId: 'injureOthers',
                          version: '2',
                          validations: {
                            required: true,
                          },
                          label:
                            'Jag är rädd för att jag kan råka skada andra människor',
                          description:
                            'Ex. Rädsla för att förgifta andras mat, rädsla för att skada spädbarn, rädsla för att knuffa någon framför tåget, rädsla för att förorsaka skada genom att ge felaktiga råd.<br>Markera om du har problemet nu eller har haft det under den senaste veckan, om du har haft problemet tidigare men inte nu, eller om du aldrig har haft problemet.',
                          index: '0.9.5.1.0.0.2',
                        },
                        {
                          id: 'compulsion.status.impulse',
                          type: 'choice',
                          options: [
                            {
                              value: 'now',
                              label: 'Nu',
                            },
                            {
                              value: 'previously',
                              label: 'Tidigare',
                            },
                            {
                              value: 'never',
                              label: 'Aldrig',
                            },
                          ],
                          relativeId: 'impulse',
                          version: '2',
                          validations: {
                            required: true,
                          },
                          label:
                            'Jag är rädd för att ett plötsligt infall ska få mig att göra något som jag inte vill',
                          description:
                            'Ex. Rädd för att köra in i ett träd, rädd för att köra över någon, rädd för att sticka ned någon med kniv.<br>Markera om du har problemet nu eller har haft det under den senaste veckan, om du har haft problemet tidigare men inte nu, eller om du aldrig har haft problemet.',
                          index: '0.9.5.1.0.0.3',
                        },
                        {
                          id: 'compulsion.status.forbiddenThoughts',
                          type: 'choice',
                          options: [
                            {
                              value: 'now',
                              label: 'Nu',
                            },
                            {
                              value: 'previously',
                              label: 'Tidigare',
                            },
                            {
                              value: 'never',
                              label: 'Aldrig',
                            },
                          ],
                          relativeId: 'forbiddenThoughts',
                          version: '2',
                          validations: {
                            required: true,
                          },
                          label:
                            'Jag har förbjudna eller perversa tankar eller inre bilder om sex, som känns obehagliga',
                          description:
                            'Ex. Sexuella tankar, som man inte själv vill ha, och som handlar om främlingar, barn, familj eller vänner. Dessa tankar skiljer sig från vanliga sexuella fantasier som ju istället upplevs som behagliga.<br>Markera om du har problemet nu eller har haft det under den senaste veckan, om du har haft problemet tidigare men inte nu, eller om du aldrig har haft problemet.',
                          index: '0.9.5.1.0.0.4',
                        },
                        {
                          id: 'compulsion.status.controlStoveOrOther',
                          type: 'choice',
                          options: [
                            {
                              value: 'now',
                              label: 'Nu',
                            },
                            {
                              value: 'previously',
                              label: 'Tidigare',
                            },
                            {
                              value: 'never',
                              label: 'Aldrig',
                            },
                          ],
                          relativeId: 'controlStoveOrOther',
                          version: '2',
                          validations: {
                            required: true,
                          },
                          label:
                            'Jag kontrollerar spisen eller andra elektriska apparater, att jag har låst eller att saker inte har försvunnit',
                          description:
                            'Ex. Upprepade kontroller av dörrlås, spis, strykjärn eller eluttagen (kontakter) innan man går hemifrån; upprepade kontroller av att ens skåp i skolan är låst eller att man satt på sig sina kläder riktigt.<br>Markera om du har problemet nu eller har haft det under den senaste veckan, om du har haft problemet tidigare men inte nu, eller om du aldrig har haft problemet.',
                          index: '0.9.5.1.0.0.5',
                        },
                        {
                          id: 'compulsion.status.heresy',
                          type: 'choice',
                          options: [
                            {
                              value: 'now',
                              label: 'Nu',
                            },
                            {
                              value: 'previously',
                              label: 'Tidigare',
                            },
                            {
                              value: 'never',
                              label: 'Aldrig',
                            },
                          ],
                          relativeId: 'heresy',
                          version: '2',
                          validations: {
                            required: true,
                          },
                          label:
                            'Jag oroar mig för att vanhelga eller häda, rädd för att förarga Gud eller vanhedra heliga ting',
                          description:
                            'Ex. Oro för hädiska tankar, för att uttrycka sig hädiskt eller bli straffad för detta längre fram i livet eller efter döden.<br>Markera om du har problemet nu eller har haft det under den senaste veckan, om du har haft problemet tidigare men inte nu, eller om du aldrig har haft problemet.',
                          index: '0.9.5.1.0.0.6',
                        },
                        {
                          id: 'compulsion.status.preventByCompulsiveActs',
                          type: 'choice',
                          options: [
                            {
                              value: 'now',
                              label: 'Nu',
                            },
                            {
                              value: 'previously',
                              label: 'Tidigare',
                            },
                            {
                              value: 'never',
                              label: 'Aldrig',
                            },
                          ],
                          relativeId: 'preventByCompulsiveActs',
                          version: '2',
                          validations: {
                            required: true,
                          },
                          label:
                            'Jag måste göra vissa saker för att det känns som om jag då kan förhindra, på ett övernaturligt sätt, att något hemskt kan inträffa',
                          description:
                            'Ex. Måste beröra saker eller personer, om man t.ex. berör en telefon (eller något liknande) får man en känsla av att man kan förhindra sjukdom i familjen.<br>Markera om du har problemet nu eller har haft det under den senaste veckan, om du har haft problemet tidigare men inte nu, eller om du aldrig har haft problemet.',
                          index: '0.9.5.1.0.0.7',
                        },
                        {
                          id: 'compulsion.status.rightAndWrong',
                          type: 'choice',
                          options: [
                            {
                              value: 'now',
                              label: 'Nu',
                            },
                            {
                              value: 'previously',
                              label: 'Tidigare',
                            },
                            {
                              value: 'never',
                              label: 'Aldrig',
                            },
                          ],
                          relativeId: 'rightAndWrong',
                          version: '2',
                          validations: {
                            required: true,
                          },
                          label:
                            'Jag är överdrivet upptagen av vad som är rätt eller fel eller moralfrågor',
                          description:
                            'Ex. Oro för att inte alltid göra ”det rätta”, att ha ljugit eller lurat någon.<br>Markera om du har problemet nu eller har haft det under den senaste veckan, om du har haft problemet tidigare men inte nu, eller om du aldrig har haft problemet.',
                          index: '0.9.5.1.0.0.8',
                        },
                        {
                          id: 'compulsion.status.symmetry',
                          type: 'choice',
                          options: [
                            {
                              value: 'now',
                              label: 'Nu',
                            },
                            {
                              value: 'previously',
                              label: 'Tidigare',
                            },
                            {
                              value: 'never',
                              label: 'Aldrig',
                            },
                          ],
                          relativeId: 'symmetry',
                          version: '2',
                          validations: {
                            required: true,
                          },
                          label:
                            'Jag har tvångstankar om att jag måste ha en viss ordning, symmetri, eller att det ska kännas exakt rätt (men det är inte kopplat till ett magiskt tänkande)',
                          description:
                            'Ex. Oroas över att papper och böcker inte är ordentligt staplade, oroas för att beräkningar eller handstilen inte är tillräckligt perfekt eller att det inte "ska gå jämt upp”.<br>Markera om du har problemet nu eller har haft det under den senaste veckan, om du har haft problemet tidigare men inte nu, eller om du aldrig har haft problemet.',
                          index: '0.9.5.1.0.0.9',
                        },
                        {
                          id: 'compulsion.status.arrangement',
                          type: 'choice',
                          options: [
                            {
                              value: 'now',
                              label: 'Nu',
                            },
                            {
                              value: 'previously',
                              label: 'Tidigare',
                            },
                            {
                              value: 'never',
                              label: 'Aldrig',
                            },
                          ],
                          relativeId: 'arrangement',
                          version: '2',
                          validations: {
                            required: true,
                          },
                          label:
                            'Jag har ett tvång att ställa i ordning eller arrangera mina saker',
                          description:
                            'Ex. Rättar till papper och pennor på skrivbordet eller böckerna i bokhyllan, ägnar mycket tid till att ställa saker ”i ordning” och blir upprörd eller arg om denna ordning rubbas.<br>Markera om du har problemet nu eller har haft det under den senaste veckan, om du har haft problemet tidigare men inte nu, eller om du aldrig har haft problemet.',
                          index: '0.9.5.1.0.0.10',
                        },
                        {
                          id: 'compulsion.status.repeating',
                          type: 'choice',
                          options: [
                            {
                              value: 'now',
                              label: 'Nu',
                            },
                            {
                              value: 'previously',
                              label: 'Tidigare',
                            },
                            {
                              value: 'never',
                              label: 'Aldrig',
                            },
                          ],
                          relativeId: 'repeating',
                          version: '2',
                          validations: {
                            required: true,
                          },
                          label:
                            'Jag måste upprepa vissa handlingar tills de känns precis rätt',
                          description:
                            'Ex. Upprepa beteenden som t.ex. att vrida av och på kranen, sätta på och stänga av apparater, kamma håret, gå fram och tillbaka över en tröskel.<br>Markera om du har problemet nu eller har haft det under den senaste veckan, om du har haft problemet tidigare men inte nu, eller om du aldrig har haft problemet.',
                          index: '0.9.5.1.0.0.11',
                        },
                        {
                          id: 'compulsion.status.hoarding',
                          type: 'choice',
                          options: [
                            {
                              value: 'now',
                              label: 'Nu',
                            },
                            {
                              value: 'previously',
                              label: 'Tidigare',
                            },
                            {
                              value: 'never',
                              label: 'Aldrig',
                            },
                          ],
                          relativeId: 'hoarding',
                          version: '2',
                          validations: {
                            required: true,
                          },
                          label: 'Jag hamstrar och samlar saker',
                          description:
                            'Ex. Sparar gamla tidningar, anteckningar, burkar, pappershanddukar och omslagspapper, av rädsla att om man kastar bort dem så kommer man en dag att behöva dem; tar med sig värdelösa saker från gatan.<br>Markera om du har problemet nu eller har haft det under den senaste veckan, om du har haft problemet tidigare men inte nu, eller om du aldrig har haft problemet.',
                          index: '0.9.5.1.0.0.12',
                        },
                        {
                          id: 'compulsion.status.bodyFixation',
                          type: 'choice',
                          options: [
                            {
                              value: 'now',
                              label: 'Nu',
                            },
                            {
                              value: 'previously',
                              label: 'Tidigare',
                            },
                            {
                              value: 'never',
                              label: 'Aldrig',
                            },
                          ],
                          relativeId: 'bodyFixation',
                          version: '2',
                          validations: {
                            required: true,
                          },
                          label:
                            'Jag tänker överdrivet mycket på någon del av kroppen eller fixerar mig vid något i mitt utseende',
                          description:
                            'Ex. Oro över att ansiktet, näsan, ögonen, eller någon annan del av kroppen är fasansfullt ful trots försäkringar från andra om motsatsen.<br>Markera om du har problemet nu eller har haft det under den senaste veckan, om du har haft problemet tidigare men inte nu, eller om du aldrig har haft problemet.',
                          index: '0.9.5.1.0.0.13',
                        },
                        {
                          id: 'compulsion.status.selfHarm',
                          type: 'choice',
                          options: [
                            {
                              value: 'now',
                              label: 'Nu',
                            },
                            {
                              value: 'previously',
                              label: 'Tidigare',
                            },
                            {
                              value: 'never',
                              label: 'Aldrig',
                            },
                          ],
                          relativeId: 'selfHarm',
                          version: '2',
                          validations: {
                            required: true,
                          },
                          label: 'Jag skadar mig själv',
                          description:
                            'Ex. River sig, drar loss hud, skär sig, bankar huvudet i väggen.<br>Markera om du har problemet nu eller har haft det under den senaste veckan, om du har haft problemet tidigare men inte nu, eller om du aldrig har haft problemet.',
                          index: '0.9.5.1.0.0.14',
                        },
                      ],
                      extras: {},
                      index: '0.9.5.1.0.0',
                    },
                  ],
                  index: '0.9.5.1.0',
                },
                {
                  type: 'section',
                  children: [
                    {
                      id: 'compulsion.time',
                      type: 'choice',
                      version: '1',
                      options: [
                        {
                          value: 0,
                          label: 'Ingen',
                        },
                        {
                          value: 1,
                          label:
                            'Mindre än 1 timme om dagen eller något enstaka tvångssymptom',
                        },
                        {
                          value: 2,
                          label:
                            '1‐3 timmar om dagen eller ofta förekommande tvångssymptom',
                        },
                        {
                          value: 3,
                          label:
                            'Mer än 3 och upp till 8 timmar om dagen eller mycket ofta förekommande',
                        },
                        {
                          value: 4,
                          label:
                            'Mer än 8 timmar om dagen eller nästan konstant förekommande',
                        },
                      ],
                      validations: {
                        required: true,
                      },
                      label:
                        'Ungefär hur mycket tid upptas av dina tvångsproblem?',
                      index: '0.9.5.1.1.0',
                    },
                    {
                      id: 'compulsion.streak',
                      type: 'choice',
                      version: '1',
                      options: [
                        {
                          value: 0,
                          label: 'Inga symptom',
                        },
                        {
                          value: 1,
                          label: 'Mer än 8 symptomfria timmar i sträck',
                        },
                        {
                          value: 2,
                          label: 'Mellan 3‐8 symptomfria timmar i sträck',
                        },
                        {
                          value: 3,
                          label: 'Mellan 1‐3 symptomfria timmar i sträck',
                        },
                        {
                          value: 4,
                          label: 'Mindre än 1 symptomfri timme i sträck',
                        },
                      ],
                      validations: {
                        required: true,
                      },
                      label:
                        'I genomsnitt, hur många vakna timmar i sträck, är du helt fri från tvångsproblemen, som mest? (timmar per dag)',
                      index: '0.9.5.1.1.1',
                    },
                    {
                      id: 'compulsion.hindrance',
                      type: 'choice',
                      version: '1',
                      options: [
                        {
                          value: 0,
                          label: 'Ingenting',
                        },
                        {
                          value: 1,
                          label:
                            'Lite; det hindrar till viss del sociala aktiviteter eller studier/yrkesliv, men den sammantagna prestationen är inte nedsatt',
                        },
                        {
                          value: 2,
                          label:
                            'Måttligt; definitivt hindrande för sociala aktiviteter eller studier/yrkesliv, men fortfarande överkomligt',
                        },
                        {
                          value: 3,
                          label:
                            'Starkt; orsakar betydande hinder för sociala aktiviteter eller studier/yrkesliv',
                        },
                        {
                          value: 4,
                          label: 'Extremt; total oförmåga',
                        },
                      ],
                      validations: {
                        required: true,
                      },
                      label:
                        'Hur mycket hindrar tvångsproblemen dig i din vardag, med arbete/skolgång och din förmåga att umgås med familj och vänner?',
                      index: '0.9.5.1.1.2',
                    },
                    {
                      id: 'compulsion.curbing',
                      type: 'choice',
                      version: '1',
                      options: [
                        {
                          value: 0,
                          label: 'Fullständig behärskning',
                        },
                        {
                          value: 1,
                          label:
                            'God behärskning, lyckas vanligen stoppa/avleda tvångssymptomen med lite ansträngning/koncentration',
                        },
                        {
                          value: 2,
                          label:
                            'Måttlig behärskning, lyckas ibland stoppa/avleda tvångssymptomen men bara med svårighet',
                        },
                        {
                          value: 3,
                          label:
                            'Dålig behärskning, lyckas sällan stoppa/avleda tvångssymptomen, men de kan skjutas upp tillfälligt',
                        },
                        {
                          value: 4,
                          label:
                            'Ingen behärskning, är knappast förmögen att ens för en kort stund strunta i tvångstankarna eller avstå från att göra tvångshandlingar; kan inte ens skjuta upp dem tillfälligt',
                        },
                      ],
                      validations: {
                        required: true,
                      },
                      label:
                        'Vilken förmåga har du att behärska dina tvångsproblem? Hur väl lyckas du stoppa eller avleda dem?',
                      description:
                        'Om du sällan försöker så tänk ändå på hur det brukar gå de sällsynta tillfällen då du försökt. OBS! räkna inte med tvångstankar som stoppas genom att utföra ritualer.',
                      index: '0.9.5.1.1.3',
                    },
                    {
                      id: 'compulsion.avoidance',
                      type: 'choice',
                      version: '1',
                      options: [
                        {
                          value: 0,
                          label: 'Inget medvetet undvikande.',
                        },
                        {
                          value: 1,
                          label: 'Lindrigt undvikande.',
                        },
                        {
                          value: 2,
                          label:
                            'Måttligt; visst undvikande beteende finns helt klart.',
                        },
                        {
                          value: 3,
                          label:
                            'Allvarligt; mycket undvikande beteende och undvikandet är framträdande.',
                        },
                        {
                          value: 4,
                          label:
                            'Extremt; mycket uttalat undvikande; gör nästan allt jag kan för att undvika att utlösa symptom.',
                        },
                      ],
                      validations: {
                        required: true,
                      },
                      label:
                        'Har du undvikit att göra något, åka någonstans eller undvikit att vara tillsammans socialt på grund av dina tvångsproblem?',
                      index: '0.9.5.1.1.4',
                    },
                    {
                      id: 'compulsion.distribution',
                      type: 'choice',
                      version: '1',
                      options: [
                        {
                          value: 'almostOnlyThoughts',
                          label: 'Nästan bara tvångstankar',
                        },
                        {
                          value: 'mostlyThoughts',
                          label: 'Mest tvångstankar men också tvångshandlingar',
                        },
                        {
                          value: 'equal',
                          label: 'Lika mycket av bägge',
                        },
                        {
                          value: 'mostlyActs',
                          label: 'Mest tvångshandlingar men också tvångstankar',
                        },
                        {
                          value: 'almostOnlyActs',
                          label: 'Nästan bara tvångshandlingar',
                        },
                      ],
                      validations: {
                        required: true,
                      },
                      label:
                        'Hur fördelar sig tvångsproblemen mellan tvångstankar och tvångshandlingar?',
                      index: '0.9.5.1.1.5',
                    },
                  ],
                  version: '1',
                  index: '0.9.5.1.1',
                },
                {
                  type: 'section',
                  children: [
                    {
                      id: 'compulsion.affected',
                      type: 'range',
                      version: '1',
                      min: {
                        value: 0,
                        label: 'Inte alls',
                      },
                      max: {
                        value: 20,
                        label: 'Extremt mycket',
                      },
                      extras: {
                        vas: true,
                        invert: false,
                      },
                      validations: {
                        required: true,
                      },
                      label:
                        'Hur mycket påverkar dina tvångstankar och/eller tvångshandlingar ditt välbefinnande? Markera på skalan.',
                      index: '0.9.5.1.2.0',
                    },
                    {
                      id: 'compulsion.social',
                      type: 'range',
                      version: '1',
                      min: {
                        value: 0,
                        label: 'Inte alls',
                      },
                      max: {
                        value: 20,
                        label: 'Extremt mycket',
                      },
                      extras: {
                        vas: true,
                        invert: false,
                      },
                      validations: {
                        required: true,
                      },
                      label:
                        'Hur mycket har tvångsproblemen påverkat dina sociala aktiviteter? Markera på skalan.',
                      index: '0.9.5.1.2.1',
                    },
                  ],
                  version: '1',
                  index: '0.9.5.1.2',
                },
              ],
              version: '1',
              index: '0.9.5.1',
            },
          ],
          version: '1',
          index: '0.9.5',
        },
        {
          type: 'section',
          children: [
            {
              type: 'section',
              children: [
                {
                  id: 'ptsd.match',
                  type: 'choice',
                  options: [
                    {
                      value: 'yes',
                      label:
                        'Jag har utsatts för något av detta och besväras av en del sådana symptom.',
                    },
                    {
                      value: 'no',
                      label: 'Jag har inte utsatts för något av detta.',
                    },
                  ],
                  version: '1',
                  validations: {
                    required: true,
                  },
                  description:
                    '  <p>\n    När människor utsätts för akuta, livshotande eller extremt obehagliga upplevelser kan det för en del personer vara svårt att komma över detta.\n  </p>\n\n  <p>\n    Samma symptom kan uppstå efter en period av svår och långvarig psykisk belastning (mer än ett år), man "går in i väggen".\n  </p>\n\n  <p>\n    I efterförloppet kan symptom förekomma i form av minnesbilder som tränger sig på, sömnstörning med mardrömmar, flash-backs där traumat upplevs på nytt, känslomässig avdomning, ökad irritabilitet, svårigheter att fokusera tänkandet, minnes- och sömnproblem.\n  </p>',
                  index: '0.9.6.0.0',
                },
              ],
              index: '0.9.6.0',
            },
            {
              type: 'section',
              condition: "get('answers.ptsd.match') === 'yes'",
              children: [
                {
                  type: 'section',
                  children: [
                    {
                      id: 'ptsd.experience.extremes',
                      type: 'composite',
                      version: '2',
                      children: [
                        {
                          id: 'ptsd.experience.extremes.childAbuse',
                          type: 'choice',
                          options: [
                            {
                              value: 0,
                              label: 'Nej',
                            },
                            {
                              value: 1,
                              label: 'En gång',
                            },
                            {
                              value: 2,
                              label: 'Flera gånger',
                            },
                            {
                              value: 3,
                              label: 'Många gånger',
                            },
                          ],
                          relativeId: 'childAbuse',
                          version: '2',
                          validations: {
                            required: true,
                          },
                          label:
                            'Som barn, blev du någon gång svårt fysiskt misshandlad av dina föräldrar eller de som uppfostrade dig?',
                          description:
                            'Frågan handlar om extrema upplevelser som du varit med om och som brukar ge upphov till svåra skräckreaktioner hos de flesta människor. Om du har varit med om händelser som beskrivs ovan, försök att ange hur många gånger det har inträffat.',
                          index: '0.9.6.1.0.0.0',
                        },
                        {
                          id: 'ptsd.experience.extremes.abuse',
                          type: 'choice',
                          options: [
                            {
                              value: 0,
                              label: 'Nej',
                            },
                            {
                              value: 1,
                              label: 'En gång',
                            },
                            {
                              value: 2,
                              label: 'Flera gånger',
                            },
                            {
                              value: 3,
                              label: 'Många gånger',
                            },
                          ],
                          relativeId: 'abuse',
                          version: '2',
                          validations: {
                            required: true,
                          },
                          label:
                            'Har du misshandlats svårt fysiskt av någon annan, närstående eller främmande?',
                          description:
                            'Frågan handlar om extrema upplevelser som du varit med om och som brukar ge upphov till svåra skräckreaktioner hos de flesta människor. Om du har varit med om händelser som beskrivs ovan, försök att ange hur många gånger det har inträffat.',
                          index: '0.9.6.1.0.0.1',
                        },
                        {
                          id: 'ptsd.experience.extremes.weapon',
                          type: 'choice',
                          options: [
                            {
                              value: 0,
                              label: 'Nej',
                            },
                            {
                              value: 1,
                              label: 'En gång',
                            },
                            {
                              value: 2,
                              label: 'Flera gånger',
                            },
                            {
                              value: 3,
                              label: 'Många gånger',
                            },
                          ],
                          relativeId: 'weapon',
                          version: '2',
                          validations: {
                            required: true,
                          },
                          label:
                            'Har du blivit rånad eller hotad med ett vapen?',
                          description:
                            'Frågan handlar om extrema upplevelser som du varit med om och som brukar ge upphov till svåra skräckreaktioner hos de flesta människor. Om du har varit med om händelser som beskrivs ovan, försök att ange hur många gånger det har inträffat.',
                          index: '0.9.6.1.0.0.2',
                        },
                        {
                          id:
                            'ptsd.experience.extremes.relativeSuddenUnexpectedLoss',
                          type: 'choice',
                          options: [
                            {
                              value: 0,
                              label: 'Nej',
                            },
                            {
                              value: 1,
                              label: 'En gång',
                            },
                            {
                              value: 2,
                              label: 'Flera gånger',
                            },
                            {
                              value: 3,
                              label: 'Många gånger',
                            },
                          ],
                          relativeId: 'relativeSuddenUnexpectedLoss',
                          version: '2',
                          validations: {
                            required: true,
                          },
                          label:
                            'Har någon dig närstående avlidit plötsligt och oväntat genom t.ex. olycka, mord, självmord eller av hjärtattack i unga år?',
                          description:
                            'Frågan handlar om extrema upplevelser som du varit med om och som brukar ge upphov till svåra skräckreaktioner hos de flesta människor. Om du har varit med om händelser som beskrivs ovan, försök att ange hur många gånger det har inträffat.',
                          index: '0.9.6.1.0.0.3',
                        },
                        {
                          id:
                            'ptsd.experience.extremes.relativeKidnappedTorturedRaped',
                          type: 'choice',
                          options: [
                            {
                              value: 0,
                              label: 'Nej',
                            },
                            {
                              value: 1,
                              label: 'En gång',
                            },
                            {
                              value: 2,
                              label: 'Flera gånger',
                            },
                            {
                              value: 3,
                              label: 'Många gånger',
                            },
                          ],
                          relativeId: 'relativeKidnappedTorturedRaped',
                          version: '2',
                          validations: {
                            required: true,
                          },
                          label:
                            'Har någon dig mycket närstående genomgått en extremt traumatisk händelse, t.ex. kidnapping, tortyr eller våldtäkt?',
                          description:
                            'Frågan handlar om extrema upplevelser som du varit med om och som brukar ge upphov till svåra skräckreaktioner hos de flesta människor. Om du har varit med om händelser som beskrivs ovan, försök att ange hur många gånger det har inträffat.',
                          index: '0.9.6.1.0.0.4',
                        },
                        {
                          id: 'ptsd.experience.extremes.witnessInjuryDeath',
                          type: 'choice',
                          options: [
                            {
                              value: 0,
                              label: 'Nej',
                            },
                            {
                              value: 1,
                              label: 'En gång',
                            },
                            {
                              value: 2,
                              label: 'Flera gånger',
                            },
                            {
                              value: 3,
                              label: 'Många gånger',
                            },
                          ],
                          relativeId: 'witnessInjuryDeath',
                          version: '2',
                          validations: {
                            required: true,
                          },
                          label:
                            'Har du sett någon skadas allvarligt eller dödas, eller oväntat sett en död kropp?',
                          description:
                            'Frågan handlar om extrema upplevelser som du varit med om och som brukar ge upphov till svåra skräckreaktioner hos de flesta människor. Om du har varit med om händelser som beskrivs ovan, försök att ange hur många gånger det har inträffat.',
                          index: '0.9.6.1.0.0.5',
                        },
                        {
                          id:
                            'ptsd.experience.extremes.escapedDangerOrPersecution',
                          type: 'choice',
                          options: [
                            {
                              value: 0,
                              label: 'Nej',
                            },
                            {
                              value: 1,
                              label: 'En gång',
                            },
                            {
                              value: 2,
                              label: 'Flera gånger',
                            },
                            {
                              value: 3,
                              label: 'Många gånger',
                            },
                          ],
                          relativeId: 'escapedDangerOrPersecution',
                          version: '2',
                          validations: {
                            required: true,
                          },
                          label:
                            'Har du flytt från ditt hem till ett främmande land eller plats för att undkomma fara eller förföljelse?',
                          description:
                            'Frågan handlar om extrema upplevelser som du varit med om och som brukar ge upphov till svåra skräckreaktioner hos de flesta människor. Om du har varit med om händelser som beskrivs ovan, försök att ange hur många gånger det har inträffat.',
                          index: '0.9.6.1.0.0.6',
                        },
                        {
                          id: 'ptsd.experience.extremes.lifeThreateningTravel',
                          type: 'choice',
                          options: [
                            {
                              value: 0,
                              label: 'Nej',
                            },
                            {
                              value: 1,
                              label: 'En gång',
                            },
                            {
                              value: 2,
                              label: 'Flera gånger',
                            },
                            {
                              value: 3,
                              label: 'Många gånger',
                            },
                          ],
                          relativeId: 'lifeThreateningTravel',
                          version: '2',
                          validations: {
                            required: true,
                          },
                          label:
                            'Har du varit inblandad i en livshotande olycka i samband med resa (bil, flyg, båt)?',
                          description:
                            'Frågan handlar om extrema upplevelser som du varit med om och som brukar ge upphov till svåra skräckreaktioner hos de flesta människor. Om du har varit med om händelser som beskrivs ovan, försök att ange hur många gånger det har inträffat.',
                          index: '0.9.6.1.0.0.7',
                        },
                        {
                          id: 'ptsd.experience.extremes.otherLifeThreatened',
                          type: 'choice',
                          options: [
                            {
                              value: 0,
                              label: 'Nej',
                            },
                            {
                              value: 1,
                              label: 'En gång',
                            },
                            {
                              value: 2,
                              label: 'Flera gånger',
                            },
                            {
                              value: 3,
                              label: 'Många gånger',
                            },
                          ],
                          relativeId: 'otherLifeThreatened',
                          version: '2',
                          validations: {
                            required: true,
                          },
                          label:
                            'Har du varit med om någon annan livshotande olycka, privat eller i arbetslivet?',
                          description:
                            'Frågan handlar om extrema upplevelser som du varit med om och som brukar ge upphov till svåra skräckreaktioner hos de flesta människor. Om du har varit med om händelser som beskrivs ovan, försök att ange hur många gånger det har inträffat.',
                          index: '0.9.6.1.0.0.8',
                        },
                      ],
                      extras: {},
                      index: '0.9.6.1.0.0',
                    },
                  ],
                  index: '0.9.6.1.0',
                },
                {
                  type: 'section',
                  children: [
                    {
                      id: 'ptsd.experience.influence',
                      type: 'choice',
                      version: '2',
                      options: [
                        {
                          value: 1,
                          label: '1 Inte alls berörd',
                        },
                        {
                          value: 2,
                          label: 2,
                        },
                        {
                          value: 3,
                          label: '3 Måttligt berörd',
                        },
                        {
                          value: 4,
                          label: 4,
                        },
                        {
                          value: 5,
                          label: '5 Ganska berörd',
                        },
                        {
                          value: 6,
                          label: 6,
                        },
                        {
                          value: 7,
                          label: '7 Extremt berörd',
                        },
                      ],
                      validations: {
                        required: true,
                      },
                      label:
                        'Försök bedöma hur psykiskt påverkad du var just efter den värsta av dessa händelser.',
                      description:
                        'Föreställ dig en skala som går från 1 till 7. 1 är att inte alls vara berörd. 7 är en total skräckupplevelse som gör en helt oförmögen att tänka och fungera i den aktuella situationen.',
                      index: '0.9.6.1.1.0',
                    },
                    {
                      id: 'ptsd.experience.when',
                      type: 'choice',
                      options: [
                        {
                          value: 'months',
                          label: 'Under de senaste månaderna',
                        },
                        {
                          value: 'year',
                          label: 'Under det senaste året',
                        },
                        {
                          value: 'between1and2years',
                          label: 'För mellan ett och två år sedan',
                        },
                        {
                          value: 'between2and5years',
                          label: 'För mellan två och fem år sedan',
                        },
                        {
                          value: 'between5and10years',
                          label: 'För mellan fem och tio år sedan',
                        },
                        {
                          value: 'moreThan10years',
                          label: 'För mer än tio år sedan',
                        },
                      ],
                      version: '1',
                      validations: {
                        required: true,
                      },
                      label:
                        'När inträffade händelsen? (det värsta du varit med om)',
                      index: '0.9.6.1.1.1',
                    },
                    {
                      id: 'ptsd.experience.age',
                      type: 'choice',
                      version: '1',
                      options: [
                        {
                          value: 'under2Years',
                          label: 'Under 2 år',
                        },
                        {
                          value: '2To7Years',
                          label: '2 - 7 år',
                        },
                        {
                          value: '8To13Years',
                          label: '8 - 13 år',
                        },
                        {
                          value: '14To20Years',
                          label: '14 - 20 år',
                        },
                        {
                          value: '21To35Years',
                          label: '21 - 35 år',
                        },
                        {
                          value: '36To60Years',
                          label: '36 - 60 år',
                        },
                        {
                          value: 'over60Years',
                          label: 'Äldre än 60 år',
                        },
                      ],
                      validations: {
                        required: true,
                      },
                      label: 'Hur gammal var du när händelsen inträffade?',
                      index: '0.9.6.1.1.2',
                    },
                    {
                      id: 'ptsd.experience.duration',
                      type: 'choice',
                      version: '1',
                      options: [
                        {
                          value: 'under2Months',
                          label: 'Under mindre än två månader',
                        },
                        {
                          value: 'under1Year',
                          label: 'Under mindre än ett år',
                        },
                        {
                          value: 'between1And2Years',
                          label: 'Mellan ett och två år',
                        },
                        {
                          value: 'between2And5Years',
                          label: 'Mellan två och fem år',
                        },
                        {
                          value: 'moreThan5Years',
                          label: 'Under mer än fem år',
                        },
                      ],
                      validations: {
                        required: true,
                      },
                      label: 'Hur länge var du påverkad av händelsen?',
                      index: '0.9.6.1.1.3',
                    },
                    {
                      id: 'ptsd.experience.now',
                      type: 'choice',
                      version: '1',
                      options: [
                        {
                          value: 0,
                          label: 'Nej',
                        },
                        {
                          value: 1,
                          label: 'Ja, lite grann',
                        },
                        {
                          value: 2,
                          label: 'Ja, ganska mycket',
                        },
                        {
                          value: 3,
                          label: 'Ja, väldigt mycket',
                        },
                        {
                          value: 4,
                          label: 'Ja, extremt mycket',
                        },
                      ],
                      validations: {
                        required: true,
                      },
                      label: 'Är du fortfarande påverkad av händelsen?',
                      index: '0.9.6.1.1.4',
                    },
                  ],
                  version: '1',
                  condition: "get('variables.ptsd.experience.sum') > 0",
                  index: '0.9.6.1.1',
                },
                {
                  type: 'section',
                  children: [
                    {
                      type: 'section',
                      children: [
                        {
                          id: 'burnout.match',
                          type: 'choice',
                          version: '1',
                          options: [
                            {
                              value: 'yes',
                              label: 'Jag har nog sådana problem',
                            },
                            {
                              value: 'no',
                              label: 'Jag har inte sådana problem',
                            },
                          ],
                          validations: {
                            required: true,
                          },
                          description:
                            '  <p>\n    Efter en period av svår och långvarig psykisk belastning förekommer det att man "går in i väggen". Man kan kalla det "utbrändhet", när man inte återhämtar sig trots att det gått lång tid sedan belastningen upphörde.\n  </p>\n\n  <p>\n    Har du varit, eller är fortfarande utsatt för en svår och långvarig psykisk belastning som resulterat i att du mår väldigt dåligt och inte kan låta bli att tänka på det som hänt; har du förlorat intresse och engagemang, kan inte fokusera, har minnes- och sömnproblem, ihållande negativa tankar, är irritabel och har "kort stubin"?\n  </p>',
                          index: '0.9.6.1.2.0.0',
                        },
                      ],
                      index: '0.9.6.1.2.0',
                    },
                    {
                      type: 'section',
                      condition: "get('answers.burnout.match') === 'yes'",
                      children: [
                        {
                          id: 'burnout.influence',
                          type: 'choice',
                          version: '1',
                          options: [
                            {
                              value: 1,
                              label: '1 Inte alls berörd',
                            },
                            {
                              value: 2,
                              label: 2,
                            },
                            {
                              value: 3,
                              label: '3 Måttligt berörd',
                            },
                            {
                              value: 4,
                              label: 4,
                            },
                            {
                              value: 5,
                              label: '5 Ganska berörd',
                            },
                            {
                              value: 6,
                              label: 6,
                            },
                            {
                              value: 7,
                              label: '7 Extremt berörd',
                            },
                          ],
                          validations: {
                            required: true,
                          },
                          label:
                            'Försök bedöma hur psykiskt påverkad du var när det var som värst under perioden av extrem belastning?',
                          index: '0.9.6.1.2.1.0',
                        },
                        {
                          id: 'burnout.now',
                          version: '1',
                          type: 'choice',
                          options: [
                            {
                              value: 0,
                              label: 'Nej',
                            },
                            {
                              value: 1,
                              label: 'Ja, lite grann',
                            },
                            {
                              value: 2,
                              label: 'Ja, ganska mycket',
                            },
                            {
                              value: 3,
                              label: 'Ja, väldigt mycket',
                            },
                            {
                              value: 4,
                              label: 'Ja, extremt mycket',
                            },
                          ],
                          validations: {
                            required: true,
                          },
                          label:
                            'Är du fortfarande påverkad av denna period av extrem/långvarig belastning?',
                          index: '0.9.6.1.2.1.1',
                        },
                      ],
                      version: '1',
                      index: '0.9.6.1.2.1',
                    },
                  ],
                  version: '1',
                  index: '0.9.6.1.2',
                },
                {
                  type: 'section',
                  condition:
                    "get('answers.ptsd.experience.now') >= 3 || get('answers.burnout.now') >= 3",
                  children: [
                    {
                      type: 'section',
                      children: [
                        {
                          id: 'burnout.status',
                          type: 'composite',
                          version: '2',
                          children: [
                            {
                              id: 'burnout.status.painfulMemories',
                              type: 'choice',
                              options: [
                                {
                                  value: 1,
                                  label: 'Ja',
                                },
                                {
                                  value: 0,
                                  label: 'Nej',
                                },
                              ],
                              relativeId: 'painfulMemories',
                              version: '2',
                              validations: {
                                required: true,
                              },
                              label:
                                'Plågsamma minnen av traumat/perioden tränger sig in i mitt medvetande.',
                              description:
                                'Ange hur du har påverkats av traumat (den akuta episoden eller den utdragna belastningen) över tid.',
                              index: '0.9.6.1.3.0.0.0',
                            },
                            {
                              id: 'burnout.status.nightmares',
                              type: 'choice',
                              options: [
                                {
                                  value: 1,
                                  label: 'Ja',
                                },
                                {
                                  value: 0,
                                  label: 'Nej',
                                },
                              ],
                              relativeId: 'nightmares',
                              version: '2',
                              validations: {
                                required: true,
                              },
                              label:
                                'Jag har ofta mardrömmar som handlar om traumat/perioden.',
                              description:
                                'Ange hur du har påverkats av traumat (den akuta episoden eller den utdragna belastningen) över tid.',
                              index: '0.9.6.1.3.0.0.1',
                            },
                            {
                              id: 'burnout.status.flashbacks',
                              type: 'choice',
                              options: [
                                {
                                  value: 1,
                                  label: 'Ja',
                                },
                                {
                                  value: 0,
                                  label: 'Nej',
                                },
                              ],
                              relativeId: 'flashbacks',
                              version: '2',
                              validations: {
                                required: true,
                              },
                              label:
                                'Jag får flash-backs under vilka jag återupplever traumat/perioden.',
                              description:
                                'Ange hur du har påverkats av traumat (den akuta episoden eller den utdragna belastningen) över tid.',
                              index: '0.9.6.1.3.0.0.2',
                            },
                            {
                              id: 'burnout.status.avoidance',
                              type: 'choice',
                              options: [
                                {
                                  value: 1,
                                  label: 'Ja',
                                },
                                {
                                  value: 0,
                                  label: 'Nej',
                                },
                              ],
                              relativeId: 'avoidance',
                              version: '2',
                              validations: {
                                required: true,
                              },
                              label:
                                'Jag undviker situationer och människor som påminner mig om traumat/perioden.',
                              description:
                                'Ange hur du har påverkats av traumat (den akuta episoden eller den utdragna belastningen) över tid.',
                              index: '0.9.6.1.3.0.0.3',
                            },
                            {
                              id: 'burnout.status.indifference',
                              type: 'choice',
                              options: [
                                {
                                  value: 1,
                                  label: 'Ja',
                                },
                                {
                                  value: 0,
                                  label: 'Nej',
                                },
                              ],
                              relativeId: 'indifference',
                              version: '2',
                              validations: {
                                required: true,
                              },
                              label:
                                'Jag har förlorat intressen jag hade och blivit likgiltig för andra människor.',
                              description:
                                'Ange hur du har påverkats av traumat (den akuta episoden eller den utdragna belastningen) över tid.',
                              index: '0.9.6.1.3.0.0.4',
                            },
                            {
                              id: 'burnout.status.unsafe',
                              type: 'choice',
                              options: [
                                {
                                  value: 1,
                                  label: 'Ja',
                                },
                                {
                                  value: 0,
                                  label: 'Nej',
                                },
                              ],
                              relativeId: 'unsafe',
                              version: '2',
                              validations: {
                                required: true,
                              },
                              label:
                                'Jag känner mig sällan trygg och avslappnad.',
                              description:
                                'Ange hur du har påverkats av traumat (den akuta episoden eller den utdragna belastningen) över tid.',
                              index: '0.9.6.1.3.0.0.5',
                            },
                            {
                              id: 'burnout.status.rage',
                              type: 'choice',
                              options: [
                                {
                                  value: 1,
                                  label: 'Ja',
                                },
                                {
                                  value: 0,
                                  label: 'Nej',
                                },
                              ],
                              relativeId: 'rage',
                              version: '2',
                              validations: {
                                required: true,
                              },
                              label:
                                'Jag reagerar med svårkontrollerbar ilska på bagateller.',
                              description:
                                'Ange hur du har påverkats av traumat (den akuta episoden eller den utdragna belastningen) över tid.',
                              index: '0.9.6.1.3.0.0.6',
                            },
                            {
                              id: 'burnout.status.concentration',
                              type: 'choice',
                              options: [
                                {
                                  value: 1,
                                  label: 'Ja',
                                },
                                {
                                  value: 0,
                                  label: 'Nej',
                                },
                              ],
                              relativeId: 'concentration',
                              version: '2',
                              validations: {
                                required: true,
                              },
                              label:
                                'Jag har svårt att koncentrera mig - tappar tråden.',
                              description:
                                'Ange hur du har påverkats av traumat (den akuta episoden eller den utdragna belastningen) över tid.',
                              index: '0.9.6.1.3.0.0.7',
                            },
                            {
                              id: 'burnout.status.memory',
                              type: 'choice',
                              options: [
                                {
                                  value: 1,
                                  label: 'Ja',
                                },
                                {
                                  value: 0,
                                  label: 'Nej',
                                },
                              ],
                              relativeId: 'memory',
                              version: '2',
                              validations: {
                                required: true,
                              },
                              label: 'Jag har fått besvärande minnesproblem.',
                              description:
                                'Ange hur du har påverkats av traumat (den akuta episoden eller den utdragna belastningen) över tid.',
                              index: '0.9.6.1.3.0.0.8',
                            },
                          ],
                          extras: {},
                          index: '0.9.6.1.3.0.0',
                        },
                      ],
                      index: '0.9.6.1.3.0',
                    },
                    {
                      type: 'section',
                      children: [
                        {
                          id: 'burnout.affected',
                          type: 'range',
                          version: '1',
                          min: {
                            value: 0,
                            label: 'Inte alls',
                          },
                          max: {
                            value: 20,
                            label: 'Extremt mycket',
                          },
                          extras: {
                            vas: true,
                            invert: false,
                          },
                          validations: {
                            required: true,
                          },
                          label:
                            'Du har beskrivit besvär i efterförloppet till en extrem händelse eller långvarig belastning. Hur mycket påverkas ditt välbefinnande av denna typen av problem? Markera på skalan.',
                          index: '0.9.6.1.3.1.0',
                        },
                        {
                          id: 'burnout.social',
                          type: 'range',
                          version: '1',
                          min: {
                            value: 0,
                            label: 'Inte alls',
                          },
                          max: {
                            value: 20,
                            label: 'Extremt mycket',
                          },
                          extras: {
                            vas: true,
                            invert: false,
                          },
                          validations: {
                            required: true,
                          },
                          label:
                            'Hur mycket begränsar sådana problem dig i sociala sammanhang? Markera på skalan.',
                          index: '0.9.6.1.3.1.1',
                        },
                      ],
                      version: '1',
                      index: '0.9.6.1.3.1',
                    },
                  ],
                  version: '1',
                  index: '0.9.6.1.3',
                },
              ],
              version: '1',
              index: '0.9.6.1',
            },
          ],
          version: '1',
          index: '0.9.6',
        },
      ],
      version: '1',
      index: '0.9',
    },
    {
      type: 'section',
      children: [
        {
          type: 'section',
          children: [
            {
              id: 'sleep.match',
              type: 'choice',
              options: [
                {
                  value: 'yes',
                  label: 'Jag har problem med sömnen nu',
                },
                {
                  value: 'no',
                  label: 'Jag har inte problem med sömnen nu',
                },
              ],
              version: '1',
              validations: {
                required: true,
              },
              description:
                '  <p>\n    Att ha sömnbesvär är mycket vanligt. I de flesta fall är besvären\n    övergående och utlösta av t. ex. tillfälliga problem och stress.\n    Kvinnor har något oftare än män besvär med sömnen.\n  </p>\n\n  <p>\n    Sömnbesvär kan man ha utan att man har andra problem, varken kroppsliga\n    (t.ex. värk) eller psykiska (t.ex. oro och nedstämdhet). Men både värk\n    och oro/nedstämdhet medför vanligen att man sover sämre. En mindre vanlig\n    form av sömnproblem är att man sover för mycket (mer än 9 timmar per\n    dygn).\n  </p>',
              index: '0.10.0.0',
            },
          ],
          index: '0.10.0',
        },
        {
          type: 'section',
          condition: "get('answers.sleep.match') === 'yes'",
          children: [
            {
              type: 'section',
              children: [
                {
                  id: 'sleep.issues.fallingAsleep',
                  type: 'composite',
                  version: '1',
                  children: [
                    {
                      id: 'sleep.issues.fallingAsleep.timeTo',
                      type: 'choice',
                      options: [
                        {
                          value: 0,
                          label: 'Inom 30 minuter',
                        },
                        {
                          value: 1,
                          label: 'Inom en timme',
                        },
                        {
                          value: 2,
                          label: 'Det dröjer mer än en timme',
                        },
                      ],
                      relativeId: 'timeTo',
                      version: '1',
                      validations: {
                        required: true,
                      },
                      label: 'Hur snabbt brukar du somna i vanliga fall?',
                      index: '0.10.1.0.0.0',
                    },
                    {
                      id: 'sleep.issues.fallingAsleep.tooLong',
                      type: 'choice',
                      options: [
                        {
                          value: 0,
                          label: 'Sällan',
                        },
                        {
                          value: 1,
                          label: 'Någon gång i veckan',
                        },
                        {
                          value: 2,
                          label: 'Hälften av kvällarna',
                        },
                        {
                          value: 3,
                          label: 'De flesta kvällarna',
                        },
                      ],
                      relativeId: 'tooLong',
                      version: '1',
                      validations: {
                        required: true,
                      },
                      label:
                        'Hur ofta tycker du att det tar för lång tid att somna?',
                      index: '0.10.1.0.0.1',
                    },
                    {
                      id: 'sleep.issues.fallingAsleep.medicate',
                      type: 'choice',
                      options: [
                        {
                          value: 0,
                          label: 'Aldrig/Sällan',
                        },
                        {
                          value: 1,
                          label: 'Någon gång i veckan',
                        },
                        {
                          value: 2,
                          label: 'Hälften av kvällarna',
                        },
                        {
                          value: 3,
                          label: 'De flesta kvällarna',
                        },
                      ],
                      relativeId: 'medicate',
                      version: '1',
                      validations: {
                        required: true,
                      },
                      label: 'Händer det att du tar sömnmedel för att somna?',
                      index: '0.10.1.0.0.2',
                    },
                    {
                      id: 'sleep.issues.fallingAsleep.cause',
                      type: 'choice',
                      options: [
                        {
                          value: 'physical',
                          label: 'Pga värk och andra kroppsliga besvär',
                        },
                        {
                          value: 'mental',
                          label: 'Pga psykiska besvär',
                        },
                        {
                          value: 'other',
                          label: 'Annat eller vet ej',
                        },
                      ],
                      relativeId: 'cause',
                      version: '1',
                      validations: {
                        required: true,
                      },
                      label: 'Varför tror du att du har insomningsproblem?',
                      index: '0.10.1.0.0.3',
                    },
                  ],
                  extras: {},
                  index: '0.10.1.0.0',
                },
              ],
              version: '1',
              index: '0.10.1.0',
            },
            {
              type: 'section',
              children: [
                {
                  id: 'sleep.issues.sleeping',
                  type: 'composite',
                  version: '1',
                  children: [
                    {
                      id: 'sleep.issues.sleeping.keepWakingUp',
                      type: 'choice',
                      options: [
                        {
                          value: 0,
                          label: 'Sällan',
                        },
                        {
                          value: 1,
                          label: 'Någon gång i veckan',
                        },
                        {
                          value: 2,
                          label: 'Hälften av nätterna',
                        },
                        {
                          value: 3,
                          label: 'De flesta nätterna',
                        },
                      ],
                      relativeId: 'keepWakingUp',
                      version: '1',
                      validations: {
                        required: true,
                      },
                      label: 'Jag vaknar upprepade gånger, sover oroligt',
                      index: '0.10.1.1.0.0',
                    },
                    {
                      id: 'sleep.issues.sleeping.unpleasantDreams',
                      type: 'choice',
                      options: [
                        {
                          value: 0,
                          label: 'Sällan',
                        },
                        {
                          value: 1,
                          label: 'Någon gång i veckan',
                        },
                        {
                          value: 2,
                          label: 'Hälften av nätterna',
                        },
                        {
                          value: 3,
                          label: 'De flesta nätterna',
                        },
                      ],
                      relativeId: 'unpleasantDreams',
                      version: '1',
                      validations: {
                        required: true,
                      },
                      label: 'Jag har obehagliga drömmar som jag vaknar av',
                      index: '0.10.1.1.0.1',
                    },
                    {
                      id: 'sleep.issues.sleeping.snoringAndStopBreathing',
                      type: 'choice',
                      options: [
                        {
                          value: 'unknown',
                          label: 'Jag vet inte',
                        },
                        {
                          value: 0,
                          label: 'Sällan',
                        },
                        {
                          value: 1,
                          label: 'Någon gång i veckan',
                        },
                        {
                          value: 2,
                          label: 'Hälften av nätterna',
                        },
                        {
                          value: 3,
                          label: 'De flesta nätterna',
                        },
                      ],
                      relativeId: 'snoringAndStopBreathing',
                      version: '1',
                      validations: {
                        required: true,
                      },
                      label:
                        'Jag snarkar mycket och har andningsuppehåll flera gånger per natt',
                      index: '0.10.1.1.0.2',
                    },
                  ],
                  extras: {},
                  index: '0.10.1.1.0',
                },
              ],
              version: '1',
              index: '0.10.1.1',
            },
            {
              type: 'section',
              children: [
                {
                  id: 'sleep.issues.wakingUp',
                  type: 'composite',
                  version: '1',
                  children: [
                    {
                      id: 'sleep.issues.wakingUp.tooEarly',
                      type: 'choice',
                      options: [
                        {
                          value: 0,
                          label: 'Sällan',
                        },
                        {
                          value: 1,
                          label: 'Någon gång i veckan',
                        },
                        {
                          value: 2,
                          label: 'Hälften av nätterna',
                        },
                        {
                          value: 3,
                          label: 'De flesta nätterna',
                        },
                      ],
                      relativeId: 'tooEarly',
                      version: '1',
                      validations: {
                        required: true,
                      },
                      label: 'Jag sover inte färdigt utan vaknar för tidigt',
                      index: '0.10.1.2.0.0',
                    },
                    {
                      id: 'sleep.issues.wakingUp.feelBad',
                      type: 'choice',
                      options: [
                        {
                          value: 0,
                          label: 'Sällan',
                        },
                        {
                          value: 1,
                          label: 'Någon gång i veckan',
                        },
                        {
                          value: 2,
                          label: 'Hälften av dagarna',
                        },
                        {
                          value: 3,
                          label: 'De flesta dagarna',
                        },
                      ],
                      relativeId: 'feelBad',
                      version: '1',
                      validations: {
                        required: true,
                      },
                      label:
                        'Jag mår dåligt pga för lite sömn, känner mig olustig och inte utsövd',
                      index: '0.10.1.2.0.1',
                    },
                    {
                      id: 'sleep.issues.wakingUp.problemGettingUp',
                      type: 'choice',
                      options: [
                        {
                          value: 0,
                          label: 'Sällan',
                        },
                        {
                          value: 1,
                          label: 'Någon gång i veckan',
                        },
                        {
                          value: 2,
                          label: 'Hälften av dagarna',
                        },
                        {
                          value: 3,
                          label: 'De flesta dagarna',
                        },
                      ],
                      relativeId: 'problemGettingUp',
                      version: '1',
                      validations: {
                        required: true,
                      },
                      label: 'Jag har stora problem att komma upp på morgonen',
                      index: '0.10.1.2.0.2',
                    },
                  ],
                  extras: {},
                  index: '0.10.1.2.0',
                },
              ],
              version: '1',
              index: '0.10.1.2',
            },
            {
              type: 'section',
              children: [
                {
                  id: 'sleep.issues.dayTiredness',
                  type: 'composite',
                  version: '1',
                  children: [
                    {
                      id: 'sleep.issues.dayTiredness.unfocused',
                      type: 'choice',
                      options: [
                        {
                          value: 0,
                          label: 'Sällan',
                        },
                        {
                          value: 1,
                          label: 'Någon gång i veckan',
                        },
                        {
                          value: 2,
                          label: 'Hälften av dagarna',
                        },
                        {
                          value: 3,
                          label: 'De flesta dagarna',
                        },
                      ],
                      relativeId: 'unfocused',
                      version: '1',
                      validations: {
                        required: true,
                      },
                      label:
                        'Jag känner mig trött och ofokuserad under dagtid, fungerar dåligt',
                      index: '0.10.1.3.0.0',
                    },
                    {
                      id: 'sleep.issues.dayTiredness.tired',
                      type: 'choice',
                      options: [
                        {
                          value: 0,
                          label: 'Sällan',
                        },
                        {
                          value: 1,
                          label: 'Någon gång i veckan',
                        },
                        {
                          value: 2,
                          label: 'Hälften av dagarna',
                        },
                        {
                          value: 3,
                          label: 'De flesta dagarna',
                        },
                      ],
                      relativeId: 'tired',
                      version: '1',
                      validations: {
                        required: true,
                      },
                      label:
                        'Jag blir så trött att jag måste sova en stund under dagen',
                      index: '0.10.1.3.0.1',
                    },
                  ],
                  extras: {},
                  index: '0.10.1.3.0',
                },
              ],
              version: '1',
              index: '0.10.1.3',
            },
            {
              type: 'section',
              children: [
                {
                  id: 'sleep.issues.oversleeping',
                  type: 'composite',
                  version: '1',
                  children: [
                    {
                      id: 'sleep.issues.oversleeping.moreThan9Hours',
                      type: 'choice',
                      options: [
                        {
                          value: 0,
                          label: 'Sällan',
                        },
                        {
                          value: 1,
                          label: 'Någon gång i veckan',
                        },
                        {
                          value: 2,
                          label: 'Hälften av dagarna',
                        },
                        {
                          value: 3,
                          label: 'De flesta dagarna',
                        },
                      ],
                      relativeId: 'moreThan9Hours',
                      version: '1',
                      validations: {
                        required: true,
                      },
                      label: 'Jag sover mer än 9 timmar per dygn',
                      index: '0.10.1.4.0.0',
                    },
                  ],
                  extras: {},
                  index: '0.10.1.4.0',
                },
              ],
              version: '1',
              index: '0.10.1.4',
            },
            {
              type: 'section',
              children: [
                {
                  id: 'sleep.issues.affected',
                  type: 'range',
                  version: '1',
                  min: {
                    value: 0,
                    label: 'Inte alls',
                  },
                  max: {
                    value: 20,
                    label: 'Extremt mycket',
                  },
                  extras: {
                    vas: true,
                    invert: false,
                  },
                  validations: {
                    required: true,
                  },
                  label:
                    'Hur mycket påverkas ditt välbefinnande av dina sömnproblem? Markera på skalan.',
                  index: '0.10.1.5.0',
                },
                {
                  id: 'sleep.issues.social',
                  type: 'range',
                  version: '1',
                  min: {
                    value: 0,
                    label: 'Inte alls',
                  },
                  max: {
                    value: 20,
                    label: 'Extremt mycket',
                  },
                  extras: {
                    vas: true,
                    invert: false,
                  },
                  validations: {
                    required: true,
                  },
                  label:
                    'Hur mycket begränsar dina sömnproblem dig i sociala sammanhang? Markera på skalan.',
                  index: '0.10.1.5.1',
                },
              ],
              version: '1',
              index: '0.10.1.5',
            },
          ],
          version: '1',
          index: '0.10.1',
        },
      ],
      version: '1',
      condition: "get('answers.sleep.well') === 'no'",
      index: '0.10',
    },
    {
      type: 'section',
      children: [
        {
          id: 'alcohol.habits',
          type: 'composite',
          version: '2',
          children: [
            {
              id: 'alcohol.habits.frequency',
              type: 'choice',
              options: [
                {
                  value: 0,
                  label: 'Aldrig',
                },
                {
                  value: 1,
                  label: '1 gång i månaden eller mer sällan',
                },
                {
                  value: 2,
                  label: '2-4 gånger i månaden',
                },
                {
                  value: 3,
                  label: '2-3 gånger i veckan',
                },
                {
                  value: 4,
                  label: '4 gånger/vecka eller mer',
                },
              ],
              relativeId: 'frequency',
              version: '2',
              validations: {
                required: true,
              },
              label: 'Hur ofta dricker du alkohol?',
              description:
                'Du har tidigare skrivit att du tror att dina nuvarande besvär kan vara kopplade till din alkoholkonsumtion. Därför kommer du nu få svara på ett antal frågor om din alkoholkonsumtion.',
              index: '0.11.0.0',
            },
            {
              id: 'alcohol.habits.amountPerDay',
              type: 'choice',
              options: [
                {
                  value: 0,
                  label: '1 - 2',
                },
                {
                  value: 1,
                  label: '3 - 4',
                },
                {
                  value: 2,
                  label: '5 - 6',
                },
                {
                  value: 3,
                  label: '7 - 9',
                },
                {
                  value: 4,
                  label: '10 eller fler',
                },
              ],
              relativeId: 'amountPerDay',
              version: '2',
              validations: {
                required: true,
              },
              label:
                'Hur många "glas" (se exempel) dricker du en typisk dag då du dricker alkohol?',
              description:
                '  Exempel:<br/>\n  Med ett "glas" menas<br/>\n  <i>50 cl folköl</i><br/>\n  <i>33 cl starköl</i><br/>\n  <i>1 glas vin</i><br/>\n  <i>1 litet glas starkvin</i><br/>\n  <i>4 cl starksprit</i>',
              index: '0.11.0.1',
            },
            {
              id: 'alcohol.habits.binge',
              type: 'choice',
              options: [
                {
                  value: 0,
                  label: 'Aldrig',
                },
                {
                  value: 1,
                  label: 'Mer sällan än en gång i månaden',
                },
                {
                  value: 2,
                  label: 'Varje månad',
                },
                {
                  value: 3,
                  label: 'Varje vecka',
                },
                {
                  value: 4,
                  label: 'Dagligen eller nästan varje dag',
                },
              ],
              relativeId: 'binge',
              version: '2',
              validations: {
                required: true,
              },
              label:
                'Hur ofta dricker du sex sådana "glas" eller mer vid samma tillfälle?',
              index: '0.11.0.2',
            },
            {
              id: 'alcohol.habits.cantStop',
              type: 'choice',
              options: [
                {
                  value: 0,
                  label: 'Aldrig',
                },
                {
                  value: 1,
                  label: 'Mer sällan än en gång i månaden',
                },
                {
                  value: 2,
                  label: 'Varje månad',
                },
                {
                  value: 3,
                  label: 'Varje vecka',
                },
                {
                  value: 4,
                  label: 'Dagligen eller nästan varje dag',
                },
              ],
              relativeId: 'cantStop',
              version: '2',
              validations: {
                required: true,
              },
              label:
                'Hur ofta under det senaste året har du inte kunnat sluta dricka sedan du börjat?',
              index: '0.11.0.3',
            },
            {
              id: 'alcohol.habits.neglect',
              type: 'choice',
              options: [
                {
                  value: 0,
                  label: 'Aldrig',
                },
                {
                  value: 1,
                  label: 'Mer sällan än en gång i månaden',
                },
                {
                  value: 2,
                  label: 'Varje månad',
                },
                {
                  value: 3,
                  label: 'Varje vecka',
                },
                {
                  value: 4,
                  label: 'Dagligen eller nästan varje dag',
                },
              ],
              relativeId: 'neglect',
              version: '2',
              validations: {
                required: true,
              },
              label:
                'Hur ofta under det senaste året har du låtit bli att göra något som du borde för att du drack?',
              index: '0.11.0.4',
            },
            {
              id: 'alcohol.habits.morning',
              type: 'choice',
              options: [
                {
                  value: 0,
                  label: 'Aldrig',
                },
                {
                  value: 1,
                  label: 'Mer sällan än en gång i månaden',
                },
                {
                  value: 2,
                  label: 'Varje månad',
                },
                {
                  value: 3,
                  label: 'Varje vecka',
                },
                {
                  value: 4,
                  label: 'Dagligen eller nästan varje dag',
                },
              ],
              relativeId: 'morning',
              version: '2',
              validations: {
                required: true,
              },
              label:
                'Hur ofta under senaste året har du behövt en "drink" på morgonen efter mycket drickande dagen innan?',
              index: '0.11.0.5',
            },
            {
              id: 'alcohol.habits.guilt',
              type: 'choice',
              options: [
                {
                  value: 0,
                  label: 'Aldrig',
                },
                {
                  value: 1,
                  label: 'Mer sällan än en gång i månaden',
                },
                {
                  value: 2,
                  label: 'Varje månad',
                },
                {
                  value: 3,
                  label: 'Varje vecka',
                },
                {
                  value: 4,
                  label: 'Dagligen eller nästan varje dag',
                },
              ],
              relativeId: 'guilt',
              version: '2',
              validations: {
                required: true,
              },
              label:
                'Hur ofta under det senaste året har du haft skuldkänslor eller samvetsförebråelser på grund av ditt drickande?',
              index: '0.11.0.6',
            },
            {
              id: 'alcohol.habits.forgot',
              type: 'choice',
              options: [
                {
                  value: 0,
                  label: 'Aldrig',
                },
                {
                  value: 1,
                  label: 'Mer sällan än en gång i månaden',
                },
                {
                  value: 2,
                  label: 'Varje månad',
                },
                {
                  value: 3,
                  label: 'Varje vecka',
                },
                {
                  value: 4,
                  label: 'Dagligen eller nästan varje dag',
                },
              ],
              relativeId: 'forgot',
              version: '2',
              validations: {
                required: true,
              },
              label:
                'Hur ofta under det senaste året har du druckit så att du dagen efter inte kommit ihåg vad du sagt eller gjort?',
              index: '0.11.0.7',
            },
            {
              id: 'alcohol.habits.harmSelfOrOthers',
              type: 'choice',
              options: [
                {
                  value: 0,
                  label: 'Nej',
                },
                {
                  value: 2,
                  label: 'Ja, men inte under det senaste året',
                },
                {
                  value: 4,
                  label: 'Ja, under det senaste året',
                },
              ],
              relativeId: 'harmSelfOrOthers',
              version: '2',
              validations: {
                required: true,
              },
              label:
                'Har du eller någon annan blivit skadad på grund av ditt drickande?',
              index: '0.11.0.8',
            },
            {
              id: 'alcohol.habits.worriedOthers',
              type: 'choice',
              options: [
                {
                  value: 0,
                  label: 'Nej',
                },
                {
                  value: 2,
                  label: 'Ja, men inte under det senaste året',
                },
                {
                  value: 4,
                  label: 'Ja, under det senaste året',
                },
              ],
              relativeId: 'worriedOthers',
              version: '2',
              validations: {
                required: true,
              },
              label:
                'Har en släkting eller vän, en läkare (eller någon annan inom sjukvården) oroat sig över ditt drickande eller antytt att du borde minska på det?',
              index: '0.11.0.9',
            },
          ],
          extras: {},
          index: '0.11.0',
        },
      ],
      version: '1',
      condition: "get('answers.alcohol.related') === 'yes'",
      index: '0.11',
    },
    {
      type: 'section',
      children: [
        {
          id: 'reproduction.pregnant',
          version: '1',
          type: 'binary',
          condition: "get('answers.predefined.age') < 44",
          validations: {
            required: true,
          },
          label: 'Är du gravid?',
          warning: "get('answers.reproduction.pregnant') === 'yes'",
          index: '0.12.0',
        },
        {
          id: 'reproduction.breastfeeding',
          version: '1',
          type: 'binary',
          condition: "get('answers.predefined.age') < 46",
          validations: {
            required: true,
          },
          label: 'Ammar du?',
          warning: "get('answers.reproduction.breastfeeding') === 'yes'",
          index: '0.12.1',
        },
      ],
      version: '1',
      condition: "get('answers.predefined.gender') === 'female'",
      index: '0.12',
    },
    {
      type: 'section',
      children: [
        {
          id: 'other',
          type: 'text',
          validations: {
            required: false,
          },
          version: '1',
          label: 'Övrig medicinsk information',
          description:
            'Här kan du ange eventuell övrig information som du tror att läkaren kan behöva i sin bedömning.',
          index: '0.13.0',
        },
      ],
      index: '0.13',
    },
    {
      id: 'predefined.gender',
      type: 'predefined',
      version: '1',
      validations: {
        required: true,
      },
      index: '0.14',
    },
    {
      id: 'predefined.age',
      type: 'predefined',
      version: '1',
      validations: {
        required: true,
      },
      index: '0.15',
    },
  ],
  variables: [
    {
      id: 'mentalHealth.problem.longDuration',
      type: 'binary',
      expression:
        "get('answers.problem.similar') === 'yes' || get('answers.problem.duration') > 14",
      relativeId: 'problem.longDuration',
      version: '1',
      validations: {
        required: true,
      },
    },
    {
      id: 'mentalHealth.diagnosis',
      type: 'multipleChoice',
      options: [
        {
          value: 'depression.match',
        },
        {
          value: 'depression.relapsing',
        },
        {
          value: 'depression.dysthymia',
        },
        {
          value: 'gad',
        },
        {
          value: 'adjustment',
        },
        {
          value: 'panic',
        },
        {
          value: 'socialAnxiety',
        },
        {
          value: 'compulsion',
        },
        {
          value: 'ptsd.extremes',
        },
        {
          value: 'ptsd.burnout',
        },
        {
          value: 'alcohol.risky',
        },
        {
          value: 'alcohol.harmful',
        },
        {
          value: 'alcohol.addiction',
        },
        {
          value: 'sleep',
        },
      ],
      expression:
        "filter({ 'depression.match': get('variables.depression.diagnosis.match') === 'yes', 'depression.relapsing': get('variables.depression.diagnosis.relapsing') === 'yes', 'depression.dysthymia': get('variables.depression.diagnosis.dysthymia') === 'yes', 'gad': get('variables.gad.diagnosis.criteria') === 'yes' || get('variables.gad.diagnosis.screen') === 'yes', 'adjustment': get('variables.adjustment.diagnosis') === 'yes', 'panic': get('variables.panic.diagnosis') === 'yes', 'socialAnxiety': get('variables.socialAnxiety.diagnosis.fully') === 'yes' || get('variables.socialAnxiety.diagnosis.partly') === 'yes', 'compulsion': get('variables.compulsion.diagnosis') === 'yes', 'ptsd.extremes': get('variables.ptsd.diagnosis.extremes') === 'yes', 'ptsd.burnout': get('variables.ptsd.diagnosis.burnout') === 'yes', 'alcohol.risky': get('variables.alcohol.risky') === 'yes', 'alcohol.harmful': get('variables.alcohol.harmful') === 'yes', 'alcohol.addiction': get('variables.alcohol.addiction') === 'yes', 'sleep': get('variables.sleep.diagnosis') === 'yes' })",
      relativeId: 'diagnosis',
      version: '1',
      validations: {
        required: false,
      },
    },
    {
      id: 'mentalHealth.modules',
      type: 'multipleChoice',
      options: [
        {
          value: 'adjustment',
        },
        {
          value: 'depression',
        },
        {
          value: 'dysthymia',
        },
        {
          value: 'gad',
        },
        {
          value: 'panic',
        },
        {
          value: 'socialAnxiety',
        },
        {
          value: 'compulsion',
        },
        {
          value: 'ptsd',
        },
        {
          value: 'burnout',
        },
        {
          value: 'alcohol',
        },
        {
          value: 'sleep',
        },
      ],
      expression:
        "filter({ 'adjustment': get('answers.adjustment.match') === 'yes', 'depression': get('answers.depression.match') === 'yes', 'dysthymia': get('answers.dysthymia.match') === 'yes', 'gad': get('answers.gad.match') === 'yes', 'panic': get('answers.panic.match') === 'yes', 'socialAnxiety': get('answers.socialAnxiety.match') === 'yes', 'compulsion': get('answers.compulsion.match') === 'yes', 'ptsd': get('answers.ptsd.match') === 'yes', 'burnout': get('answers.burnout.match') === 'yes', 'alcohol': get('answers.alcohol.related') === 'yes', 'sleep': get('answers.sleep.match') === 'yes' })",
      relativeId: 'modules',
      version: '1',
      validations: {
        required: false,
      },
    },
    {
      id: 'mentalHealth.screen',
      type: 'abort',
      expression: "get('answers.mentalHealth.screen') === 'yes'",
      relativeId: 'screen',
      version: '1',
      validations: {
        required: true,
      },
    },
    {
      id: 'had.anxiety.sum',
      type: 'number',
      expression:
        "get('answers.had.status.tense') + get('answers.had.status.horrible') + get('answers.had.status.worry') + get('answers.had.status.relaxed') + get('answers.had.status.butterflies') + get('answers.had.status.restless') + get('answers.had.status.panic')",
      relativeId: 'anxiety.sum',
      version: '1',
      validations: {
        required: true,
      },
    },
    {
      id: 'had.depression.sum',
      type: 'number',
      expression:
        "get('answers.had.status.appreciative') + get('answers.had.status.laugh') + get('answers.had.status.goodMood') + get('answers.had.status.slow') + get('answers.had.status.appearance') + get('answers.had.status.lookForwardTo') + get('answers.had.status.bookTvRadio')",
      relativeId: 'depression.sum',
      version: '1',
      validations: {
        required: true,
      },
    },
    {
      id: 'adjustment.diagnosis',
      type: 'binary',
      expression:
        "( get('answers.adjustment.incident') === 'yes' || get('answers.adjustment.strain') === 'yes' ) && ( ( ( get('answers.adjustment.status.depressed') + get('answers.adjustment.status.lackOfJoy') + get('answers.adjustment.status.reclusive') ) > 4 ? 1 : 0 ) + ( ( get('answers.adjustment.status.worriedAnxiousTense') + get('answers.adjustment.status.worried') + get('answers.adjustment.status.heartbeatSweating') ) > 4 ? 1 : 0 ) + ( get('answers.adjustment.status.concentration') > 0 ? 1 : 0 ) + ( ( get('answers.adjustment.status.troubleFallingAsleep') + get('answers.adjustment.status.troubleSleeping') + get('answers.adjustment.status.wakeUpRested') ) > 4 ? 1 : 0 ) ) > 2 && ( get('answers.adjustment.affected') >= 7 || get('answers.adjustment.social') >= 7 )",
      relativeId: 'diagnosis',
      version: '1',
      validations: {
        required: true,
      },
    },
    {
      id: 'depression.diagnosis.match',
      type: 'binary',
      expression:
        "( ( get('answers.depression.status.amount') >= 2 || get('answers.depression.status.lackOfJoy') >= 2 ) && ( get('answers.depression.status.noInterestInFriendsAndHobbies') + get('answers.depression.status.darkFuture') + get('answers.depression.status.guilt') + get('answers.depression.status.worriedAnxiousTense') + get('answers.depression.status.seriousDisease') + get('answers.depression.status.disconnected') ) > 10 && ( get('answers.depression.affected') >= 7 || get('answers.depression.social') >= 7 ) ) || ( ( get('answers.depression.status.amount') >= 2 || get('answers.depression.status.lackOfJoy') >= 2 ) && ( get('answers.depression.status.noInterestInFriendsAndHobbies') + get('answers.depression.status.darkFuture') + get('answers.depression.status.guilt') + get('answers.depression.status.worriedAnxiousTense') + get('answers.depression.status.seriousDisease') + get('answers.depression.status.disconnected') ) >= 8 && ( get('answers.depression.status.noInterestInFriendsAndHobbies') + get('answers.depression.status.darkFuture') + get('answers.depression.status.guilt') + get('answers.depression.status.worriedAnxiousTense') + get('answers.depression.status.seriousDisease') + get('answers.depression.status.disconnected') ) <= 10 && get('answers.depression.affected') >= 7 && get('answers.depression.social') >= 7 )",
      relativeId: 'diagnosis.match',
      version: '1',
      validations: {
        required: true,
      },
    },
    {
      id: 'depression.diagnosis.relapsing',
      type: 'binary',
      expression:
        "( get('answers.depression.history.suicidal') + ( get('answers.depression.history.suicidal') > 0 ? get('answers.depression.history.suicideAttempts') * 3 : 0 ) + get('answers.depression.history.passiveHarm') ) > 3 && ( get('answers.depression.affected') >= 7 || get('answers.depression.social') >= 7 )",
      relativeId: 'diagnosis.relapsing',
      version: '1',
      validations: {
        required: true,
      },
    },
    {
      id: 'depression.diagnosis.dysthymia',
      type: 'binary',
      expression:
        "( (get('answers.dysthymia.status.appetiteIssues') === 'yes' ? 1 : 0) + (get('answers.dysthymia.status.sleepIssues') === 'yes' ? 1 : 0) + (get('answers.dysthymia.status.lowEnergy') === 'yes' ? 1 : 0) + (get('answers.dysthymia.status.lowSelfEsteem') === 'yes' ? 1 : 0) + (get('answers.dysthymia.status.hardToConcentrate') === 'yes' ? 1 : 0) + (get('answers.dysthymia.status.hopeless') === 'yes' ? 1 : 0) ) > 1 && get('answers.dysthymia.status.recurring') === 'yes' && ( get('answers.dysthymia.affected') >= 7 || get('answers.dysthymia.social') >= 7 )",
      relativeId: 'diagnosis.dysthymia',
      version: '1',
      validations: {
        required: true,
      },
    },
    {
      id: 'depression.observed.now',
      type: 'binary',
      expression: "get('answers.depression.status.meaningless') > 0",
      relativeId: 'observed.now',
      version: '1',
      validations: {
        required: true,
      },
    },
    {
      id: 'depression.observed.history',
      type: 'binary',
      expression:
        "get('answers.depression.history.suicidal') > 0 || get('answers.depression.history.passiveHarm') > 0",
      relativeId: 'observed.history',
      version: '1',
      validations: {
        required: true,
      },
    },
    {
      id: 'gad.sum',
      type: 'number',
      expression:
        "get('answers.gad.status.ache') + get('answers.gad.status.tired') + get('answers.gad.status.lowSelfEsteem') + get('answers.gad.status.tense') + get('answers.gad.status.sensitive') + get('answers.gad.status.hardToOvercome') + get('answers.gad.status.stressed') + get('answers.gad.status.worried') + get('answers.gad.status.tenseToTired') + get('answers.gad.status.anxious') + get('answers.gad.status.doubt') + get('answers.gad.status.fatigue')",
      relativeId: 'sum',
      version: '1',
      validations: {
        required: true,
      },
    },
    {
      id: 'gad.diagnosis.criteria',
      type: 'binary',
      expression:
        "( get('variables.gad.sum') > 33 && ( get('answers.gad.affected') >= 7 || get('answers.gad.social') >= 7 ) )",
      relativeId: 'diagnosis.criteria',
      version: '1',
      validations: {
        required: true,
      },
    },
    {
      id: 'gad.diagnosis.screen',
      type: 'binary',
      expression:
        "get('variables.gad.sum') > 31 && get('answers.gad.affected') >= 7 && get('answers.gad.social') >= 7",
      relativeId: 'diagnosis.screen',
      version: '1',
      validations: {
        required: true,
      },
    },
    {
      id: 'panic.diagnosis',
      type: 'binary',
      expression:
        "get('answers.panic.amount') >= 1 && length(get('answers.panic.symptoms')) > 3 && ( get('answers.panic.afraid') >= 1 || get('answers.panic.avoidance') >= 1 || get('answers.panic.unsafe') >= 1 ) && ( get('answers.panic.affected') >= 7 || get('answers.panic.social') >= 7 )",
      relativeId: 'diagnosis',
      version: '1',
      validations: {
        required: true,
      },
    },
    {
      id: 'socialAnxiety.sum',
      type: 'number',
      expression:
        "get('answers.socialAnxiety.status.embarrassed') + get('answers.socialAnxiety.status.uncomfortable') + get('answers.socialAnxiety.status.fearOfBeingObserved') + get('answers.socialAnxiety.status.fearOfPublicSpeaking') + get('answers.socialAnxiety.status.avoidance')",
      relativeId: 'sum',
      version: '1',
      validations: {
        required: true,
      },
    },
    {
      id: 'socialAnxiety.diagnosis.fully',
      type: 'binary',
      expression:
        "get('variables.socialAnxiety.sum') > 9 && ( get('answers.socialAnxiety.affected') >= 7 || get('answers.socialAnxiety.social') >= 7 )",
      relativeId: 'diagnosis.fully',
      version: '1',
      validations: {
        required: true,
      },
    },
    {
      id: 'socialAnxiety.diagnosis.partly',
      type: 'binary',
      expression:
        "get('variables.socialAnxiety.sum') >= 7 && get('variables.socialAnxiety.sum') <= 9 && get('answers.socialAnxiety.affected') >= 7 && get('answers.socialAnxiety.social') >= 7",
      relativeId: 'diagnosis.partly',
      version: '1',
      validations: {
        required: true,
      },
    },
    {
      id: 'compulsion.diagnosis',
      type: 'binary',
      expression:
        "( get('answers.compulsion.time') + get('answers.compulsion.streak') + get('answers.compulsion.hindrance') + get('answers.compulsion.curbing') + get('answers.compulsion.avoidance') ) > 6 && ( get('answers.compulsion.affected') >= 7 || get('answers.compulsion.social') >= 7 )",
      relativeId: 'diagnosis',
      version: '1',
      validations: {
        required: true,
      },
    },
    {
      id: 'compulsion.sum',
      type: 'number',
      expression:
        "(get('answers.compulsion.status.dirtDiseaseBacteriaVirus') === 'now' ? 1 : 0) + (get('answers.compulsion.status.washing') === 'now' ? 1 : 0) + (get('answers.compulsion.status.injureOthers') === 'now' ? 1 : 0) + (get('answers.compulsion.status.impulse') === 'now' ? 1 : 0) + (get('answers.compulsion.status.forbiddenThoughts') === 'now' ? 1 : 0) + (get('answers.compulsion.status.controlStoveOrOther') === 'now' ? 1 : 0) + (get('answers.compulsion.status.heresy') === 'now' ? 1 : 0) + (get('answers.compulsion.status.preventByCompulsiveActs') === 'now' ? 1 : 0) + (get('answers.compulsion.status.rightAndWrong') === 'now' ? 1 : 0) + (get('answers.compulsion.status.symmetry') === 'now' ? 1 : 0) + (get('answers.compulsion.status.arrangement') === 'now' ? 1 : 0) + (get('answers.compulsion.status.repeating') === 'now' ? 1 : 0) + (get('answers.compulsion.status.hoarding') === 'now' ? 1 : 0) + (get('answers.compulsion.status.bodyFixation') === 'now' ? 1 : 0) + (get('answers.compulsion.status.selfHarm') === 'now' ? 1 : 0)",
      relativeId: 'sum',
      version: '1',
      validations: {
        required: true,
      },
    },
    {
      id: 'ptsd.experience.sum',
      type: 'number',
      expression:
        "get('answers.ptsd.experience.extremes.childAbuse') + get('answers.ptsd.experience.extremes.abuse') + get('answers.ptsd.experience.extremes.weapon') + get('answers.ptsd.experience.extremes.relativeSuddenUnexpectedLoss') + get('answers.ptsd.experience.extremes.relativeKidnappedTorturedRaped') + get('answers.ptsd.experience.extremes.witnessInjuryDeath') + get('answers.ptsd.experience.extremes.escapedDangerOrPersecution') + get('answers.ptsd.experience.extremes.lifeThreateningTravel') + get('answers.ptsd.experience.extremes.otherLifeThreatened')",
      relativeId: 'experience.sum',
      version: '1',
      validations: {
        required: true,
      },
    },
    {
      id: 'ptsd.diagnosis.match',
      type: 'binary',
      expression:
        "( ( ( get('answers.burnout.status.painfulMemories') + get('answers.burnout.status.nightmares') + get('answers.burnout.status.flashbacks') ) > 0 ? 1 : 0 ) + get('answers.burnout.status.avoidance') + ( ( get('answers.burnout.status.indifference') + get('answers.burnout.status.unsafe') ) > 0 ? 1 : 0 ) + ( ( get('answers.burnout.status.rage') + get('answers.burnout.status.concentration') + get('answers.burnout.status.memory') ) > 0 ? 1 : 0 ) ) > 1 && ( get('answers.burnout.affected') >= 7 || get('answers.burnout.social') >= 7 )",
      relativeId: 'diagnosis.match',
      version: '1',
      validations: {
        required: true,
      },
    },
    {
      id: 'ptsd.diagnosis.extremes',
      type: 'binary',
      expression:
        "get('variables.ptsd.diagnosis.match') === 'yes' && get('variables.ptsd.experience.sum') > 0 && get('answers.ptsd.experience.now') > 1",
      relativeId: 'diagnosis.extremes',
      version: '1',
      validations: {
        required: true,
      },
    },
    {
      id: 'ptsd.diagnosis.burnout',
      type: 'binary',
      expression:
        "get('variables.ptsd.diagnosis.match') === 'yes' && get('answers.burnout.match') === 'yes' && get('answers.burnout.now') > 1",
      relativeId: 'diagnosis.burnout',
      version: '1',
      validations: {
        required: true,
      },
    },
    {
      id: 'sleep.vas',
      type: 'binary',
      expression:
        "get('answers.sleep.issues.affected') >= 7 || get('answers.sleep.issues.social') >= 7",
      relativeId: 'vas',
      version: '1',
      validations: {
        required: true,
      },
    },
    {
      id: 'sleep.check.fallingAsleep',
      type: 'binary',
      expression:
        "get('variables.sleep.vas') === 'yes' && ( get('answers.sleep.issues.fallingAsleep.timeTo') + get('answers.sleep.issues.fallingAsleep.tooLong') + get('answers.sleep.issues.fallingAsleep.medicate') ) > 1",
      relativeId: 'check.fallingAsleep',
      version: '1',
      validations: {
        required: true,
      },
    },
    {
      id: 'sleep.check.sleeping',
      type: 'binary',
      expression:
        "get('variables.sleep.vas') === 'yes' && ( ( get('answers.sleep.issues.sleeping.keepWakingUp') + get('answers.sleep.issues.sleeping.unpleasantDreams') ) > 1 || ( get('answers.sleep.issues.sleeping.snoringAndStopBreathing') !== 'unknown' ? get('answers.sleep.issues.sleeping.snoringAndStopBreathing') : 0 ) > 1 )",
      relativeId: 'check.sleeping',
      version: '1',
      validations: {
        required: true,
      },
    },
    {
      id: 'sleep.check.wakingUp',
      type: 'binary',
      expression:
        "get('variables.sleep.vas') === 'yes' && ( get('answers.sleep.issues.wakingUp.tooEarly') + get('answers.sleep.issues.wakingUp.feelBad') + get('answers.sleep.issues.wakingUp.problemGettingUp') ) > 1",
      relativeId: 'check.wakingUp',
      version: '1',
      validations: {
        required: true,
      },
    },
    {
      id: 'sleep.check.dayTiredness',
      type: 'binary',
      expression:
        "get('variables.sleep.vas') === 'yes' && ( get('answers.sleep.issues.dayTiredness.unfocused') + get('answers.sleep.issues.dayTiredness.tired') ) > 1",
      relativeId: 'check.dayTiredness',
      version: '1',
      validations: {
        required: true,
      },
    },
    {
      id: 'sleep.check.oversleeping',
      type: 'binary',
      expression:
        "get('variables.sleep.vas') === 'yes' && get('answers.sleep.issues.oversleeping.moreThan9Hours') > 1",
      relativeId: 'check.oversleeping',
      version: '1',
      validations: {
        required: true,
      },
    },
    {
      id: 'sleep.diagnosis',
      type: 'binary',
      expression:
        "any( 'yes', get('variables.sleep.check.fallingAsleep'), get('variables.sleep.check.sleeping'), get('variables.sleep.check.wakingUp'), get('variables.sleep.check.dayTiredness'), get('variables.sleep.check.oversleeping') )",
      relativeId: 'diagnosis',
      version: '1',
      validations: {
        required: true,
      },
    },
    {
      id: 'alcohol.sum',
      type: 'number',
      expression:
        "get('answers.alcohol.habits.frequency') + get('answers.alcohol.habits.amountPerDay') + get('answers.alcohol.habits.binge') + get('answers.alcohol.habits.cantStop') + get('answers.alcohol.habits.neglect') + get('answers.alcohol.habits.morning') + get('answers.alcohol.habits.guilt') + get('answers.alcohol.habits.forgot') + get('answers.alcohol.habits.harmSelfOrOthers') + get('answers.alcohol.habits.worriedOthers')",
      relativeId: 'sum',
      version: '1',
      validations: {
        required: true,
      },
    },
    {
      id: 'alcohol.risky',
      type: 'binary',
      expression:
        "8 <= get('variables.alcohol.sum') && get('variables.alcohol.sum') <= 15",
      relativeId: 'risky',
      version: '1',
      validations: {
        required: true,
      },
    },
    {
      id: 'alcohol.harmful',
      type: 'binary',
      expression:
        "16 <= get('variables.alcohol.sum') && get('variables.alcohol.sum') <= 20",
      relativeId: 'harmful',
      version: '1',
      validations: {
        required: true,
      },
    },
    {
      id: 'alcohol.addiction',
      type: 'binary',
      expression: "21 <= get('variables.alcohol.sum')",
      relativeId: 'addiction',
      version: '1',
      validations: {
        required: true,
      },
    },
  ],
  views: {
    summary: {
      children: [
        {
          id: 'summary',
          type: 'comment',
          version: '1',
          validations: {
            required: true,
          },
        },
      ],
      type: 'view',
      version: '1',
      validations: {
        required: true,
      },
    },
    clinic: {
      children: [
        {
          type: 'section',
          children: [
            {
              id: 'mentalHealth.currentContact',
              warning: "get('answers.mentalHealth.currentContact') === 'yes'",
              type: 'question',
              version: '1',
              extras: {},
              label:
                'Har annan kontinuerlig kontakt med psykiatri/husläkare/vårdcentral för dessa besvär',
              description: '',
            },
          ],
          version: '1',
        },
        {
          type: 'section',
          children: [
            {
              id: 'clinic.social',
              type: 'text',
              version: '1',
              validations: {
                required: true,
              },
              label: 'Psykosocialt',
              template:
                "(get('answers.predefined.gender') === 'male' ? 'Man' : 'Kvinna') + ', ' + (get('answers.predefined.age') ? get('answers.predefined.age') + ', ' : '') + 'bor ' + { alone: 'ensam', partnerAndOrChildren: 'med partner och/eller barn', parents: 'med föräldrar', other: 'alternativt' }[get('answers.social.livingArrangement')] + '. ' + 'Familjerelationer ' + { good: 'goda', mostlyGood: 'i huvudsak goda', complicated: 'komplicerade', poor: 'dåliga' }[get('answers.social.familyRelations')] + (get('answers.social.haveFriends') === 'no' ? ', inga vänner' : '') + '. ' + 'Har ' + { basic: 'grundskola', highSchool: 'gymnasieskola', collegeUniversity: 'högskola/universitet' }[get('answers.education.level')] + ', ' + 'sysselsättning ' + { office: 'kontorsarbete', sales: 'försäljning', industry: 'industri/verkstad', construction: 'bygg/anläggning', transport: 'transport', healthcare: 'hälso- och sjukvård', unemployed: 'arbetslös', other: 'annat' }[get('answers.work.what')] + ( get('answers.work.what') !== 'unemployed' ? ( ', ' + (get('answers.work.selfEmployed') === 'yes' ? 'egen företagare, ' : '') + (get('answers.work.shift') === 'yes' ? 'skiftarbete, ' : '') + 'sysselsättningsgrad ' + { fullTime: 'heltid', partTime: 'deltid', leaveOfAbsence: 'tjänstledig', sickLeave: 'sjukskriven', other: 'oklart' }[get('answers.work.amount.type')] + '. ' + ( get('answers.work.amount.type') === 'sickLeave' ? ( 'Sjukskriven ' + { lessThanMonth: 'mindre än en månad', moreThanMonth: 'mer än en månad', moreThan6Months: 'mer än 6 månader' }[get('answers.work.amount.sickLeaveWhen')] + ', ' + 'orsak ' + { chronic: 'kronisk sjukdom', tear: 'förslitningsskada', mental: 'psykiska besvär', accident: 'olycksfall', other: 'oklart' }[get('answers.work.amount.sickLeaveWhy')] + '. ' ) : '' ) + ( get('answers.work.happy') < 4 ? 'Är missnöjd med gällande sysselsättning.' : '' ) ) : '.' )",
            },
          ],
          version: '1',
        },
        {
          type: 'section',
          children: [
            {
              id: 'clinic.problems',
              type: 'text',
              version: '1',
              validations: {
                required: true,
              },
              label: 'Aktuellt',
              template:
                "'Besvär sedan ' + { 2: 'några dagar', 7: 'en vecka', 14: '2-3 veckor', 31: 'en månad', 90: 'flera månader', 365: 'ett år', 730: 'flera år' }[get('answers.problem.duration')] + ', ' + 'dessa uppträder ' + { daily: 'dagligen', multipleTimesAWeek: 'flera gånger i veckan', weekly: 'någon gång i veckan' }[get('answers.problem.frequency')] + ', ' + ( get('answers.problem.similar') === 'yes' ? ( 'tidigare psykiska besvär ' + { 'month': 'för ca en månad sedan', '6months': 'för ca ett halvår sedan', 'year': 'för ca ett år sedan', 'severalYears': 'för flera år sedan' }[get('answers.problem.similarWhen')] + '. ' + ( length(get('answers.problem.similarTreatment.what')) > 0 ? ( 'Tidigare behandling: ' + filter({ 'antidepressiv': contains(get('answers.problem.similarTreatment.what'), 'antidepressive'), 'lugnande': contains(get('answers.problem.similarTreatment.what'), 'calming'), 'sömnmedel': contains(get('answers.problem.similarTreatment.what'), 'sleeping'), 'stämningsstabiliserande': contains(get('answers.problem.similarTreatment.what'), 'moodStabilizing'), 'antipsykotisk': contains(get('answers.problem.similarTreatment.what'), 'antipsychotic'), 'sköldkörtelhormon': contains(get('answers.problem.similarTreatment.what'), 'thyroidGlandHormone'), 'psykoterapi': contains(get('answers.problem.similarTreatment.what'), 'psychoTherapy'), 'ingen/vet ej': contains(get('answers.problem.similarTreatment.what'), 'unknown') }).join(', ') + '. ' ) : '' ) ) : 'inga tidigare psykiska besvär. ' ) + (get('answers.mentalHealth.relatives.match') === 'yes' ? 'Hereditet. ' : '') + ( length(get('answers.mentalHealth.recentHardships.match')) > 0 ? ( 'Under det senaste året svårigheter inom följande områden: ' + filter({ 'familj': contains(get('answers.mentalHealth.recentHardships.match'), 'family'), 'arbete': contains(get('answers.mentalHealth.recentHardships.match'), 'work'), 'ekonomi': contains(get('answers.mentalHealth.recentHardships.match'), 'economy'), 'socialt': contains(get('answers.mentalHealth.recentHardships.match'), 'social'), 'varit med om en olycka': contains(get('answers.mentalHealth.recentHardships.match'), 'accident'), 'utsatt för brott': contains(get('answers.mentalHealth.recentHardships.match'), 'crime'), 'skilsmässa': contains(get('answers.mentalHealth.recentHardships.match'), 'divorce'), 'allvarlig sjukdom': contains(get('answers.mentalHealth.recentHardships.match'), 'seriousIllness'), 'närståendes död': contains(get('answers.mentalHealth.recentHardships.match'), 'death') }).join(', ') + '.' ) : '' )",
            },
            {
              id: 'reproduction.pregnant',
              type: 'question',
              version: '1',
              extras: {},
              label: 'Gravid',
              description: '',
            },
            {
              id: 'reproduction.breastfeeding',
              type: 'question',
              version: '1',
              extras: {},
              label: 'Ammar',
              description: '',
            },
            {
              id: 'mentalHealth.recentHardships.followup',
              type: 'question',
              version: '1',
              extras: {},
              label:
                'Patientens egen beskrivning av sina svårigheter det senaste året',
              description: '',
            },
          ],
          version: '1',
        },
        {
          type: 'section',
          children: [
            {
              id: 'clinic.other',
              type: 'text',
              version: '1',
              validations: {
                required: true,
              },
              label: 'Övrig information',
              template:
                "( get('answers.exercise.regularly') === 'yes' ? 'Motionerar regelbundet. ' : '' ) + ( get('answers.exercise.regularly') === 'no' ? 'Motionerar ej. ' : '' ) + ( get('answers.sleep.well') === 'yes' ? 'Inga sömnproblem. ' : '' ) + ( get('answers.sleep.well') === 'no' ? ( 'Sömnproblem, ' + ( get('answers.sleep.recentIssues') === 'yes' ? 'nytillkomna' : 'ej nytillkomna' ) + '. ' ) : '' ) + ( get('answers.reproduction.pms') === 'yes' ? 'PMS. ' : '' ) + ( get('answers.health.hormones') === 'yes' ? 'Hormonrubbning. ' : '' ) + ( get('answers.reproduction.recentlyInLabor') === 'yes' ? 'Nyligen partus. ' : '' ) + ( get('answers.reproduction.menopause') === 'yes' ? 'Menopaus. ' : '' ) + ( get('answers.reproduction.menopause') === 'unknown' ? 'Möjlig menopaus. ' : '' ) + ( get('answers.health.chronicPain') === 'yes' ? 'Besväras av långvarig smärta. ' : '' ) + ( get('answers.alcohol.related') === 'yes' ? 'Patienten är orolig kring sin alkoholkonsumtion. ' : '' )",
            },
            {
              id: 'other',
              condition: "get('answers.other')",
              type: 'question',
              version: '1',
              extras: {},
              label: 'Patientens egen beskrivning i övrig information',
              description: '',
            },
          ],
          version: '1',
        },
        {
          type: 'section',
          children: [
            {
              id: 'mentalHealth.diagnosis',
              type: 'variable',
              warning: 'true',
              version: '1',
              label: 'Arbetsdiagnoser',
              options: [
                {
                  label: 'Depression',
                  value: 'depression.match',
                },
                {
                  label: 'Depression (Återkommande)',
                  value: 'depression.relapsing',
                },
                {
                  label: 'Depression (Dystymi)',
                  value: 'depression.dysthymia',
                },
                {
                  label: 'GAD',
                  value: 'gad',
                },
                {
                  label: 'Anpassningsstörning',
                  value: 'adjustment',
                },
                {
                  label: 'Paniksyndrom',
                  value: 'panic',
                },
                {
                  label: 'Social ångest',
                  value: 'socialAnxiety',
                },
                {
                  label: 'Tvångssyndrom',
                  value: 'compulsion',
                },
                {
                  label: 'PTSD (Trauma)',
                  value: 'ptsd.extremes',
                },
                {
                  label: 'PTSD (Utdragen hög belastning)',
                  value: 'ptsd.burnout',
                },
                {
                  label: 'Alkohol (Riskbruk)',
                  value: 'alcohol.risky',
                },
                {
                  label: 'Alkohol (Skadligt bruk)',
                  value: 'alcohol.harmful',
                },
                {
                  label: 'Alkohol (Beroende)',
                  value: 'alcohol.addiction',
                },
                {
                  label: 'Sömnproblem',
                  value: 'sleep',
                },
              ],
            },
            {
              id: 'clinic.noDiagnosis',
              type: 'text',
              condition:
                "length(get('variables.mentalHealth.diagnosis')) === 0",
              version: '1',
              validations: {
                required: true,
              },
              label: 'Arbetsdiagnoser',
              template: "'Inga'",
            },
          ],
          version: '1',
        },
        {
          type: 'section',
          children: [
            {
              id: 'mentalHealth.modules',
              type: 'variable',
              version: '1',
              label: 'Patienten besväras av',
              options: [
                {
                  label: 'Anpassningsstörning',
                  value: 'adjustment',
                },
                {
                  label: 'Depression',
                  value: 'depression',
                },
                {
                  label: 'Dystymi',
                  value: 'dysthymia',
                },
                {
                  label: 'GAD',
                  value: 'gad',
                },
                {
                  label: 'Paniksyndrom',
                  value: 'panic',
                },
                {
                  label: 'Social ångest',
                  value: 'socialAnxiety',
                },
                {
                  label: 'Tvångssyndrom',
                  value: 'compulsion',
                },
                {
                  label: 'PTSD',
                  value: 'ptsd',
                },
                {
                  label: 'Utdragen hög belastning',
                  value: 'burnout',
                },
                {
                  label: 'Alkohol',
                  value: 'alcohol',
                },
                {
                  label: 'Sömnproblem',
                  value: 'sleep',
                },
              ],
            },
          ],
          version: '1',
        },
        {
          id: 'had',
          type: 'section',
          children: [
            {
              id: 'had.anxiety.sum',
              type: 'variable',
              version: '1',
              label: 'Ångest',
              description:
                '  0-7 poäng: Talar ej för ångest<br/>\n  8-10 poäng: Ångest föreligger möjligen<br/>\n  ≥11 poäng: Talar för att ångest föreligger',
              unit: 'poäng',
            },
            {
              id: 'had.depression.sum',
              type: 'variable',
              version: '1',
              label: 'Depression',
              description:
                '  0-7 poäng: Talar ej för depressiva besvär<br/>\n  8-10 poäng: Depressiva besvär föreligger möjligen<br/>\n  ≥11 poäng: Talar för att depressiva besvär föreligger',
              unit: 'poäng',
            },
          ],
          version: '1',
          label: 'HAD - Symptomskattning',
        },
        {
          id: 'adjustment',
          type: 'section',
          children: [
            {
              id: 'adjustment.affected',
              type: 'question',
              version: '1',
              extras: {},
              label: 'Påverkat välbefinnande',
              min: {
                value: 0,
                label: 'Inte alls',
              },
              max: {
                value: 20,
                label: 'Extremt mycket',
              },
            },
            {
              id: 'adjustment.social',
              type: 'question',
              version: '1',
              extras: {},
              label: 'Påverkat sociala aktiviteter',
              min: {
                value: 0,
                label: 'Inte alls',
              },
              max: {
                value: 20,
                label: 'Extremt mycket',
              },
            },
          ],
          version: '1',
          label: 'Anpassningsstörning',
        },
        {
          id: 'depression',
          type: 'section',
          children: [
            {
              id: 'clinic.depression.observed',
              type: 'multipleChoice',
              condition:
                "get('variables.depression.observed.now') === 'yes' || get('variables.depression.observed.history') === 'yes'",
              warning: 'true',
              options: [
                {
                  value: 'now',
                  label:
                    'Nuvarande upplevelse av meningslöshet, bristande livslust eller suicidtankar',
                },
                {
                  value: 'history',
                  label:
                    'Tidigare passivt självskadande, suicidtankar eller försök',
                },
              ],
              expression:
                "filter({ 'now': get('variables.depression.observed.now') === 'yes', 'history': get('variables.depression.observed.history') === 'yes' })",
              version: '1',
              validations: {
                required: false,
              },
            },
            {
              id: 'depression.affected',
              type: 'question',
              version: '1',
              extras: {},
              label: 'Påverkat välbefinnande',
              min: {
                value: 0,
                label: 'Inte alls',
              },
              max: {
                value: 20,
                label: 'Extremt mycket',
              },
            },
            {
              id: 'depression.social',
              type: 'question',
              version: '1',
              extras: {},
              label: 'Påverkat sociala aktiviteter',
              min: {
                value: 0,
                label: 'Inte alls',
              },
              max: {
                value: 20,
                label: 'Extremt mycket',
              },
            },
          ],
          version: '1',
          label: 'Depression',
        },
        {
          id: 'dysthymia',
          type: 'section',
          children: [
            {
              id: 'dysthymia.affected',
              type: 'question',
              version: '1',
              extras: {},
              label: 'Påverkat välbefinnande',
              min: {
                value: 0,
                label: 'Inte alls',
              },
              max: {
                value: 20,
                label: 'Extremt mycket',
              },
            },
            {
              id: 'dysthymia.social',
              type: 'question',
              version: '1',
              extras: {},
              label: 'Påverkat sociala aktiviteter',
              min: {
                value: 0,
                label: 'Inte alls',
              },
              max: {
                value: 20,
                label: 'Extremt mycket',
              },
            },
          ],
          version: '1',
          label: 'Dystymi',
        },
        {
          id: 'gad',
          type: 'section',
          children: [
            {
              id: 'gad.affected',
              type: 'question',
              version: '1',
              extras: {},
              label: 'Påverkat välbefinnande',
              min: {
                value: 0,
                label: 'Inte alls',
              },
              max: {
                value: 20,
                label: 'Extremt mycket',
              },
            },
            {
              id: 'gad.social',
              type: 'question',
              version: '1',
              extras: {},
              label: 'Påverkat sociala aktiviteter',
              min: {
                value: 0,
                label: 'Inte alls',
              },
              max: {
                value: 20,
                label: 'Extremt mycket',
              },
            },
          ],
          version: '1',
          label: 'GAD',
        },
        {
          id: 'panic',
          type: 'section',
          children: [
            {
              id: 'panic.affected',
              type: 'question',
              version: '1',
              extras: {},
              label: 'Påverkat välbefinnande',
              min: {
                value: 0,
                label: 'Inte alls',
              },
              max: {
                value: 20,
                label: 'Extremt mycket',
              },
            },
            {
              id: 'panic.social',
              type: 'question',
              version: '1',
              extras: {},
              label: 'Påverkat sociala aktiviteter',
              min: {
                value: 0,
                label: 'Inte alls',
              },
              max: {
                value: 20,
                label: 'Extremt mycket',
              },
            },
          ],
          version: '1',
          label: 'Paniksyndrom',
        },
        {
          id: 'socialAnxiety',
          type: 'section',
          children: [
            {
              id: 'socialAnxiety.affected',
              type: 'question',
              version: '1',
              extras: {},
              label: 'Påverkat välbefinnande',
              min: {
                value: 0,
                label: 'Inte alls',
              },
              max: {
                value: 20,
                label: 'Extremt mycket',
              },
            },
            {
              id: 'socialAnxiety.social',
              type: 'question',
              version: '1',
              extras: {},
              label: 'Påverkat sociala aktiviteter',
              min: {
                value: 0,
                label: 'Inte alls',
              },
              max: {
                value: 20,
                label: 'Extremt mycket',
              },
            },
          ],
          version: '1',
          label: 'Social ångest',
        },
        {
          id: 'compulsion',
          type: 'section',
          children: [
            {
              id: 'compulsion.sum',
              type: 'variable',
              condition: "get('variables.compulsion.sum') > 0",
              version: '1',
              label: 'Antal problemområden',
            },
            {
              id: 'compulsion.distribution',
              type: 'question',
              version: '1',
              extras: {},
              description: '',
              label:
                'Hur fördelar sig tvångsproblemen mellan tvångstankar och tvångshandlingar?',
              options: [
                {
                  value: 'almostOnlyThoughts',
                  label: 'Nästan bara tvångstankar',
                },
                {
                  value: 'mostlyThoughts',
                  label: 'Mest tvångstankar men också tvångshandlingar',
                },
                {
                  value: 'equal',
                  label: 'Lika mycket av bägge',
                },
                {
                  value: 'mostlyActs',
                  label: 'Mest tvångshandlingar men också tvångstankar',
                },
                {
                  value: 'almostOnlyActs',
                  label: 'Nästan bara tvångshandlingar',
                },
              ],
            },
            {
              id: 'compulsion.affected',
              type: 'question',
              version: '1',
              extras: {},
              label: 'Påverkat välbefinnande',
              min: {
                value: 0,
                label: 'Inte alls',
              },
              max: {
                value: 20,
                label: 'Extremt mycket',
              },
            },
            {
              id: 'compulsion.social',
              type: 'question',
              version: '1',
              extras: {},
              label: 'Påverkat sociala aktiviteter',
              min: {
                value: 0,
                label: 'Inte alls',
              },
              max: {
                value: 20,
                label: 'Extremt mycket',
              },
            },
          ],
          version: '1',
          label: 'Tvångssyndrom',
        },
        {
          id: 'burnout',
          type: 'section',
          children: [
            {
              id: 'burnout.affected',
              type: 'question',
              version: '1',
              extras: {},
              label: 'Påverkat välbefinnande',
              min: {
                value: 0,
                label: 'Inte alls',
              },
              max: {
                value: 20,
                label: 'Extremt mycket',
              },
            },
            {
              id: 'burnout.social',
              type: 'question',
              version: '1',
              extras: {},
              label: 'Påverkat sociala aktiviteter',
              min: {
                value: 0,
                label: 'Inte alls',
              },
              max: {
                value: 20,
                label: 'Extremt mycket',
              },
            },
          ],
          version: '1',
          label: 'Utdragen hög belastning',
        },
        {
          id: 'sleep.issues',
          type: 'section',
          children: [
            {
              id: 'sleep.issues.affected',
              type: 'question',
              version: '1',
              extras: {},
              label: 'Påverkat välbefinnande',
              min: {
                value: 0,
                label: 'Inte alls',
              },
              max: {
                value: 20,
                label: 'Extremt mycket',
              },
            },
            {
              id: 'sleep.issues.social',
              type: 'question',
              version: '1',
              extras: {},
              label: 'Påverkat sociala aktiviteter',
              min: {
                value: 0,
                label: 'Inte alls',
              },
              max: {
                value: 20,
                label: 'Extremt mycket',
              },
            },
          ],
          version: '1',
          label: 'Sömnproblem',
        },
      ],
      type: 'view',
      version: '1',
      validations: {
        required: true,
      },
    },
  },
  label: 'Stress, oro och depression',
  index: '0',
};
